<template>
  <div>
    <div id="booking" v-cloak>
      <Alert />
      <Spinner />
      <div class="container-fluid">
        <div class="row" style="position: relative; background-color: #ddd">
          <div class="col-xs-12 text-center">
            <img
              style="width: 150px; margin-top: 30px"
              src="/ivgcs/img/mulgrave-logo.png"
            />
            <h2 style="color: #e96724; margin-bottom: 30px">
              Welcome, Mulgrave Applicants!
            </h2>
            <div style="width=300px">
              <h4 v-show="current_view == 'splash'">
                Note: Before registering below, please submit your application
                to Mulgrave at
                <a
                  href="https://www.mulgrave.com/admissions/how-to-apply"
                  target="_blank"
                  >https://www.mulgrave.com/admissions/how-to-apply</a
                >.
              </h4>
            </div>
          </div>
        </div>
      </div>

      <div class="container container-block" v-show="!configuring">
        <div id="bookingHeaderLocation" v-show="headers[current_view]">
          <center>
            <h3 class="bookingHeader">{{ headers[current_view] }}</h3>
          </center>
        </div>

        <!-- main splash page -->
        <transition name="fade">
          <div id="splash-view" v-show="false">
            <!-- v-show="current_view == 'splash'" -->
            <center class="">
              Select the type of interview you would like:
            </center>
            <div class="row">
              <div class="col-xs-12">
                <div
                  class="panel panel-default hovergray"
                  v-for="i in categoryList"
                  v-on:click.prevent="completeSplash(i)"
                >
                  <div
                    class="panel-body row"
                    style="padding-top: 0px; padding-bottom: 0px"
                  >
                    <div class="col-xs-4">
                      <img class="img-responsive" v-bind:src="i.image" />
                    </div>
                    <div class="col-xs-8">
                      <center>
                        <h4>{{ i.title }}</h4>
                        <p>{{ i.subtitle }}</p>
                      </center>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>

        <transition name="fade">
          <div
            id="type-view"
            v-show="current_view == 'splash' || current_view == 'type'"
          >
            <hr />
            <!--<h3 class="bookingHeader text-center">What are you applying for?</h3>-->
            <div class="row">
              <div class="list-group">
                <div
                  class="list-group-item hovergray"
                  v-for="i in typeList"
                  v-on:click.prevent="completeType(i)"
                >
                  <span>
                    <h4 class="list-group-item-heading" style="padding: 5px">
                      {{ i.title }}
                    </h4>
                    <!--<p class="list-group-item-text">{{i.subtitle}}</p>
                    <p class="list-group-item-text">{{i.priceUSD}} USD ({{i.priceRMB}} RMB)</p>-->
                  </span>
                </div>
              </div>
            </div>
          </div>
        </transition>

        <transition name="fade">
          <div id="locationCity-view" v-show="current_view == 'locationCity'">
            <div class="row">
              <div
                class="panel-group timezone"
                id="accordion"
                style="margin-bottom: 40px"
              >
                <!-- Begin pre-college panel -->
                <div
                  class="panel panel-accordion"
                  v-for="(country, index) in locationCityHeadings"
                >
                  <!-- Header -->
                  <button
                    class="panel-heading timezone-heading"
                    v-bind:class="{ collapsed: country != 'China' }"
                    v-bind:data-target="'#collapse-city-' + index"
                    data-toggle="collapse"
                  >
                    <h4 class="panel-title">
                      {{ locationCityList[country].country }}
                      <span class="arrow pull-right" aria-hidden="true"></span>
                    </h4>
                  </button>
                  <!-- Content -->
                  <div
                    v-bind:id="'collapse-city-' + index"
                    class="panel-collapse collapse"
                    v-bind:class="{ in: country == 'China' }"
                  >
                    <div class="panel-body">
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="list-group">
                            <div
                              class="list-group-item hovergray"
                              v-for="i in locationCityList[country].list"
                              v-on:click.prevent="completeLocationCity(i)"
                            >
                              <div class="list-group-item-heading">
                                {{ i.title }}
                                <div class="span6 pull-right">
                                  {{ i.subtitle }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>

        <transition name="fade">
          <div id="locationTz-view" v-show="current_view == 'locationTz'">
            <div class="row">
              <!--<p class="text-center">Connect online at any time with one of our experienced interviewers.</p>-->

              <div
                class="panel-group timezone"
                id="accordion"
                style="margin-bottom: 40px"
              >
                <!-- Begin pre-college panel -->
                <div
                  class="panel panel-accordion"
                  v-for="(section, index) in locationTzHeadings"
                >
                  <!-- Header -->
                  <button
                    class="panel-heading timezone-heading"
                    v-bind:class="{
                      collapsed: !contains(
                        locationTzList[section].list,
                        'timezone',
                        browser.timezone,
                      ),
                    }"
                    v-bind:data-target="'#collapse-tz-' + index"
                    data-toggle="collapse"
                  >
                    <h4 class="panel-title">
                      {{ locationTzList[section].section }}
                      <span class="arrow pull-right" aria-hidden="true"></span>
                    </h4>
                  </button>
                  <!-- Content -->
                  <div
                    v-bind:id="'collapse-tz-' + index"
                    class="panel-collapse collapse"
                    v-bind:class="{
                      in: contains(
                        locationTzList[section].list,
                        'timezone',
                        browser.timezone,
                      ),
                    }"
                  >
                    <div class="panel-body">
                      <div class="row">
                        <div class="col-sm-12">
                          <div class="list-group">
                            <div
                              class="list-group-item hovergray"
                              v-bind:class="{
                                highlight: browser.timezone == i.timezone,
                              }"
                              v-for="i in locationTzList[section].list"
                              v-on:click.prevent="completeLocationTz(i)"
                            >
                              <div class="list-group-item-heading">
                                {{ i.title }}
                                <div class="span6 pull-right">
                                  {{ i.subtitle }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>

        <transition name="fade">
          <div id="time-view" v-show="current_view == 'time'">
            <div class="row">
              <div id="booking-clndr">
                <div class="clndr">
                  <div class="clndr-left">
                    <div class="clndr-controls">
                      <div class="clndr-previous-button"></div>
                      <div class="clndr-next-button"></div>
                      <div class="current-month">{{ month }} {{ year }}</div>
                    </div>
                    <div class="clndr-grid">
                      <div class="days-of-the-week clearfix">
                        <div
                          v-for="day in daysOfTheWeek"
                          track-by="$index"
                          class="header-day"
                        >
                          {{ day }}
                        </div>
                      </div>
                      <div class="days">
                        <div
                          v-for="day in days"
                          v-bind:class="
                            day.classes + ' ' + classBynslotsPerDay(day)
                          "
                        >
                          <div class="day-wrapper">
                            <span
                              class="day-number"
                              v-bind:data-day="day.date.day()"
                              >{{ day.day }}</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="myCalendar" id="myCalendar-1"></div> -->
            </div>
            <div class="row">
              <img
                id="info-png"
                class="img-responsive"
                v-bind:src="env.staticAddr + '/s/img/booking/mInfo.png'"
              />
            </div>
            <div
              class="modal fade"
              id="myModal"
              tabindex="-1"
              role="dialog"
              aria-labelledby="myModalLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <button
                      type="button"
                      class="close"
                      v-on:click="closeModal('myModal')"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4
                      class="modal-title"
                      id="myModalLabel"
                      style="color: #e96724"
                      v-show="filteredTimeslots.length == 0"
                    >
                      ALL TIMES ARE TAKEN ON THIS DAY
                    </h4>
                    <h4
                      class="modal-title"
                      id="myModalLabel"
                      style="color: #e96724"
                      v-show="filteredTimeslots.length > 0"
                    >
                      AVAILABLE TIMES
                    </h4>
                  </div>
                  <div class="modal-body">
                    <div class="availableTimesBox">
                      <div class="panel-body timeZoneTitle">
                        <center>
                          <h4
                            v-show="chosen.type.v == 1"
                            style="margin-bottom: 0px"
                          >
                            TIME ZONE: {{ chosen.locTzName }}
                          </h4>
                          <h4
                            v-show="chosen.type.v == 2"
                            style="margin-bottom: 0px"
                          >
                            LOCATION: {{ chosen.locCity }}
                          </h4>
                          <br />
                          <h4 style="margin-top: 0px">{{ clndrDay }}</h4>
                        </center>
                      </div>
                      <div class="list-group" v-show="timeList.length > 0">
                        <div
                          class="btn btn-default list-group-item"
                          v-for="i in timesForDay(timeList, clndrDay)"
                          v-on:click.prevent="completeTime(i)"
                          v-on:click="closeModal('myModal')"
                        >
                          <center>
                            <h4>{{ i.time }}</h4>
                          </center>
                        </div>
                      </div>
                      <div
                        class="panel panel-default"
                        v-show="filteredTimeslots.length == 0"
                      >
                        <div class="panel-body row">
                          <div class="col-xs-12" v-show="chosen.type.v == 2">
                            Unfortunately, there are no available interview
                            times on this day. Please select another day above
                            or click below to change the interview location.<br />
                          </div>
                          <div class="col-xs-12" v-show="chosen.type.v == 1">
                            Unfortunately, there are no available interview
                            times on this day. Please select another day
                            above.<br />
                          </div>
                          <div class="row">
                            <div class="col-xs-12">
                              <br />
                              <center>
                                <button
                                  class="btn btn-default"
                                  v-on:click="closeModal('myModal')"
                                >
                                  Back To Calendar
                                </button>
                              </center>
                            </div>
                          </div>
                          <div class="row" v-show="chosen.type.v == 2">
                            <div class="col-xs-12">
                              <br />
                              <center>
                                <button
                                  class="btn btn-default"
                                  v-on:click.prevent="switchChosenType"
                                  v-on:click="closeModal('myModal')"
                                >
                                  Search Webcam Interview Times
                                </button>
                              </center>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-xs-12">
                              <br />
                              <center>
                                <button
                                  class="btn btn-default"
                                  v-on:click.prevent="requestTime(1)"
                                >
                                  Request a Time on This Day
                                </button>
                              </center>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-default"
                      v-on:click="closeModal('myModal')"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="modal fade"
              id="emptyMonthModal"
              tabindex="-1"
              role="dialog"
              aria-labelledby="emptyMonthModalLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <button
                      type="button"
                      class="close"
                      v-on:click="closeModal('emptyMonthModal')"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4
                      class="modal-title"
                      id="emptyMonthModalLabel"
                      style="color: #e96724"
                    >
                      ALL TIMES ARE TAKEN THIS MONTH
                    </h4>
                  </div>
                  <div class="modal-body">
                    <div class="availableTimesBox">
                      <div class="panel-body timeZoneTitle">
                        <center>
                          <h4
                            v-show="chosen.type.v == 1"
                            style="margin-bottom: 0px"
                          >
                            TIME ZONE: {{ chosen.locTzName }}
                          </h4>
                          <h4
                            v-show="chosen.type.v == 2"
                            style="margin-bottom: 0px"
                          >
                            LOCATION: {{ chosen.locCity }}
                          </h4>
                          <br />
                          <h4 style="margin-top: 0px">
                            MONTH: {{ clndrMonth }}
                          </h4>
                        </center>
                      </div>
                      <div class="panel panel-default">
                        <div class="panel-body row">
                          <center>
                            <div v-show="chosen.type.v == 1" class="col-xs-12">
                              Keep searching for open times!<br />
                            </div>
                            <div v-show="chosen.type.v == 2" class="col-xs-12">
                              <div class="alert alert-warning">
                                <p>
                                  Due to the current global health issue
                                  involving COVID-19, we have suspended
                                  in-person interviews until further notice. Our
                                  global webcam interviews continue to operate
                                  as normal, and we are able to interview and
                                  deliver the interviews and related to
                                  materials to admission offices on time and
                                  without interruption.
                                </p>
                                <p>
                                  While some may prefer in-person interviews,
                                  most of our interviews in recent years have
                                  been conducted online (in fact, some admission
                                  officers have told us that they feel that
                                  students are more relaxed when the interview
                                  is conducted online).
                                </p>
                                <p>
                                  In the event we are able to again offer
                                  in-person interviews, we will allow you to
                                  switch at no charge to an in-person interview
                                  if you wish to do so (and give us ten business
                                  days notice before the original date of your
                                  interview). Please note that in such a case we
                                  will provide preference to those who have
                                  signed up the earliest and contact us in a
                                  timely fashion.
                                </p>
                                <p>
                                  In the meantime, please rest assured that even
                                  in light of increased demand due to
                                  cancellation of standardized tests, we have
                                  enough online times throughout the spring and
                                  summer for anyone who wants to do an
                                  interview. If you are not able to find a
                                  convenient time, you can always call us at +86
                                  10 8286-3889 or email us at
                                  contact@initialview.com.
                                </p>
                                <p>
                                  We hope that everyone stays safe and healthy,
                                  and please do not hesitate to reach out if you
                                  have any questions.
                                </p>
                              </div>
                            </div>
                          </center>
                          <div class="row" v-show="chosen.type.v == 1">
                            <div class="col-xs-12">
                              <br />
                              <center>
                                <button
                                  class="btn btn-default"
                                  v-on:click.prevent="goToNextMonth"
                                >
                                  Check Next Month
                                </button>
                              </center>
                            </div>
                          </div>
                          <div class="row" v-show="chosen.type.v == 1">
                            <div class="col-xs-12">
                              <br />
                              <center>
                                <button
                                  class="btn btn-default"
                                  v-on:click.prevent="goToPreviousMonth"
                                >
                                  Check Previous Month
                                </button>
                              </center>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-xs-12">
                              <br />
                              <center>
                                <button
                                  class="btn btn-default"
                                  v-on:click.prevent="switchChosenType"
                                  v-show="chosen.type.v == 2"
                                  v-on:click="closeModal('emptyMonthModal')"
                                >
                                  Check Webcam Interview Times
                                </button>
                              </center>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-xs-12">
                              <br />
                              <center>
                                <button
                                  class="btn btn-default"
                                  v-on:click.prevent="requestTime(2)"
                                >
                                  Request a Time This Month
                                </button>
                              </center>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-default"
                      v-on:click="closeModal('emptyMonthModal')"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="modal fade"
              id="requestTimeModal"
              tabindex="-1"
              role="dialog"
              aria-labelledby="requestTimeModalLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <button
                      type="button"
                      class="close"
                      v-on:click="closeModal('requestTimeModal')"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4
                      class="modal-title"
                      id="requestTimeModalLabel"
                      v-show="chosen.type.v == 2"
                    >
                      REQUEST A TIME IN {{ chosen.locCity | upper }}
                    </h4>
                    <h4
                      class="modal-title"
                      id="requestTimeModalLabel"
                      v-show="chosen.type.v == 1"
                    >
                      REQUEST A WEBCAM INTERVIEW
                    </h4>
                  </div>
                  <div class="modal-body">
                    <form class="form-horizontal" id="requestForm">
                      <div class="form-group date" id="date-picker">
                        <label for="requestDate" class="col-xs-4 control-label"
                          >Date</label
                        >
                        <div class="col-xs-8">
                          <input
                            type="text"
                            class="form-control"
                            id="requestDate"
                            disabled
                            v-model="request.date"
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="requestName" class="col-xs-4 control-label"
                          >Name</label
                        >
                        <div class="col-xs-8">
                          <input
                            type="text"
                            class="form-control"
                            id="requestName"
                            placeholder="Your Name"
                            v-model="request.name"
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="requestEmail" class="col-xs-4 control-label"
                          >Email</label
                        >
                        <div class="col-xs-8">
                          <input
                            type="email"
                            class="form-control"
                            id="requestEmail"
                            placeholder="student@example.com"
                            v-model="request.email"
                          />
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="mobile-request-time"
                          class="col-xs-4 control-label"
                          >Mobile Number</label
                        >
                        <div class="col-xs-8">
                          <!--<input type="tel" class="form-control mobile-input" id="mobile-request-time" v-model="request.phone" placeholder="Mobile Number" 
                                    @input="validateMobile('#mobile-request-time')" @blur="validateMobile('#mobile-request-time')"> -->
                          <VueTelInput
                            :defaultCountry="showRMB ? 'cn' : 'us'"
                            :disabledFetchingCountry="true"
                            :disabledFormatting="true"
                            v-model="request.phone"
                            placeholder="Mobile Number"
                            :enabledFlags="false"
                            :enabledCountryCode="false"
                            :preferredCountries="['ca', 'cn', 'in', 'kr', 'us']"
                            inputClasses="form-control"
                            :wrapperClasses="
                              request.phone && requestBlurred && !requestValid
                                ? 'has-error'
                                : ''
                            "
                            mode="international"
                            v-on:validate="requestValid = $event.isValid"
                            v-on:country-changed="requestCountry = $event"
                            v-on:blur="requestBlurred = true"
                          >
                            <template v-slot:arrow-icon>
                              +{{ requestCountry.dialCode }}
                              {{ requestCountry.iso2 }}
                            </template>
                          </VueTelInput>
                        </div>
                      </div>
                      <div class="form-group">
                        <label
                          for="requestReason"
                          class="col-xs-4 control-label"
                          >Reason (Optional)</label
                        >
                        <div class="col-xs-8">
                          <textarea
                            class="form-control"
                            id="requestReason"
                            rows="4"
                            style="width: 100%; resize: none"
                            placeholder="Provide us with the reason?"
                            v-model="request.reason"
                          ></textarea>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-default"
                      v-on:click="closeModal('requestTimeModal')"
                    >
                      Close
                    </button>
                    <button
                      type="button"
                      class="btn btn-primary"
                      v-on:click.prevent="sendRequest"
                    >
                      Request!
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="modal fade"
              id="afterTimeRequestModal"
              tabindex="-1"
              role="dialog"
              aria-labelledby="afterTimeRequestModalLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <button
                      type="button"
                      class="close"
                      v-on:click="closeModal('afterTimeRequestModal')"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                    <h4
                      class="modal-title"
                      id="afterTimeRequestModalLabel"
                      v-show="requestLoading"
                    >
                      REQUEST BEING SENT
                    </h4>
                    <h4
                      class="modal-title"
                      id="afterTimeRequestModalLabel"
                      v-show="!requestLoading && !requestFailed"
                    >
                      REQUEST RECEIVED BY US!
                    </h4>
                    <h4
                      class="modal-title"
                      id="afterTimeRequestModalLabel"
                      v-show="!requestLoading && requestFailed"
                    >
                      REQUEST FAILED
                    </h4>
                  </div>
                  <div class="modal-body">
                    <div v-show="requestLoading">
                      <center>
                        <i
                          class="fa fa-spinner fa-spin"
                          style="font-size: 70px"
                        ></i>
                      </center>
                    </div>
                    <div v-show="!requestLoading && !requestFailed">
                      <p>Your request has been received by us!</p>
                      <p>
                        If you have any other questions, please email
                        <a href="tomail:contact@initialview.com"
                          >contact@initialview.com</a
                        >
                        or call us at +86-10-8286-3889 or +1-833-378-3886.
                      </p>
                      <p>We look forward to meeting you!</p>
                    </div>
                    <div v-show="!requestLoading && requestFailed">
                      <p>
                        Unfortunately, there might be something wrong to send
                        your request to InitialView.
                      </p>
                      <p>
                        To request a time, please email
                        <a href="tomail:contact@initialview.com"
                          >contact@initialview.com</a
                        >
                        or call us at +86-10-8286-3889 or +1-833-378-3886.
                      </p>
                      <p>We look forward to meeting you!</p>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-default"
                      v-on:click="closeModal('afterTimeRequestModal')"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div v-show="context == 'booking'">
              <p id="calendar-note-instudio" class="time-view-note">
                Can't find a time that works for you? Please email us at
                <a href="mailto:contact@initialview.com"
                  >contact@initialview.com</a
                >
                or give us a call at +86-10-8286-3889 or <br />
                +1-833-378-3886.
              </p>
            </div>
          </div>
        </transition>

        <transition name="fade">
          <div id="details-view" v-show="current_view == 'details'">
            <div class="row panel panel-default">
              <div class="panel-body">
                <div class="row">
                  <div class="col-xs-5 fieldTitle">APPLYING FOR:</div>
                  <div class="col-xs-7 fieldValue">
                    {{ chosen.applyingFor }}
                  </div>
                </div>
                <!--<div class="row"><div class="col-xs-5 fieldTitle">TYPE:</div><div class="col-xs-7 fieldValue">{{ asessement_type }}</div></div>-->

                <div class="row" v-show="chosen.type.v == 1">
                  <div class="col-xs-5 fieldTitle">TIME ZONE:</div>
                  <div class="col-xs-7 fieldValue">
                    {{ chosen.locTzName }} Time
                  </div>
                </div>
                <div class="row" v-show="chosen.type.v == 2">
                  <div class="col-xs-5 fieldTitle">CITY:</div>
                  <div class="col-xs-7 fieldValue">{{ chosen.locCity }}</div>
                </div>

                <div class="row">
                  <div class="col-xs-5 fieldTitle">DATE:</div>
                  <div class="col-xs-7 fieldValue">
                    {{ computeLocalDate }}
                    <a
                      class="edit-button"
                      href="#"
                      v-on:click.prevent="goToHash('time', 'details')"
                      ><span class="glyphicon glyphicon-pencil"></span
                    ></a>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-5 fieldTitle">TIME:</div>
                  <div class="col-xs-7 fieldValue">
                    {{ computeLocalTime }}
                    <a
                      class="edit-button"
                      href="#"
                      v-on:click.prevent="goToHash('time', 'details')"
                      ><span class="glyphicon glyphicon-pencil"></span
                    ></a>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-5 fieldTitle">AMOUNT DUE:</div>
                  <div class="col-xs-7 fieldValue">
                    {{ computePriceDisplay }}
                  </div>
                </div>
                <!--<div class="row" v-if="context == 'booking'">
                <div class="col-xs-5 fieldTitle">
                    <span v-show="!chosen.couponValid">HAVE A COUPON?</span>
                    <span v-show="chosen.couponValid">HAVE A COUPON?</span>
                </div>
                <div class="col-xs-7 fieldValue">
                    <input id="couponInput" size="14px" type="text" v-show="!chosen.couponValid" v-model="chosen.coupon" placeholder="coupon code">
                    <button style="margin-top:3px; margin-right:10px;" type="submit" class="btn btn-xs orangeBackground pull-right" v-show="!chosen.couponValid && chosen.coupon != null" v-on:click.prevent="checkCoupon()">APPLY</button>
                    <span v-show="chosen.couponValid && !rush_only">{{computePercent}}% off (coupon applied)</span>
                    <span v-show="chosen.couponValid && rush_only">Free rush processing (a $120 value!)</span>
                    <span class="glyphicon glyphicon-ok"></span>
                </div>
            </div>-->
                <div class="row">
                  <div class="col-xs-12">
                    <form>
                      <div class="form-group">
                        <center>
                          <button
                            type="submit"
                            class="btn btn-primary"
                            v-on:click.prevent="completeDetails()"
                          >
                            CONTINUE
                          </button>
                        </center>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>

        <transition name="fade">
          <div id="rush-view" v-show="current_view == 'rush'">
            <div class="row panel panel-default">
              <div class="panel-body">
                <div class="row">
                  <div class="col-xs-12">
                    <div class="fieldTitle">
                      Your interview is on {{ computeLocalDate }}
                    </div>
                    <div class="fieldTitle">RECEIVE INTERVIEW BY:</div>
                    <div class="list-group">
                      <div
                        class="list-group-item hovergray"
                        v-bind:class="{ highlight: i.id == chosen.rushID }"
                        v-for="i in rushableList"
                        v-on:click.prevent="selectRush(i)"
                      >
                        <h4 class="list-group-item-heading">
                          {{ computeLocalProcessingDate(i.id) }}
                        </h4>
                        <p class="list-group-item-text">{{ i.language }}</p>
                        <p class="list-group-item-text">
                          {{ i.priceLanguage }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-6 fieldTitle">TOTAL AMOUNT DUE:</div>
                  <div class="col-xs-6 fieldValue">
                    {{ computeTotalPriceDisplay }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12">
                    <form>
                      <div class="form-group">
                        <center>
                          <!-- <button v-show="rushSelected()" class="btn btn-primary" v-on:click="completeRush()">CONTINUE</a> -->
                          <!-- VERY strange behavior - for some reason, setting location.hash after completeRush is reloading the page with a ? before the hash. It's not happening for any other transition, and there's no good reason why it should be happening for this transition. Setting the href directly works around it. -->
                          <a
                            v-show="rushSelected()"
                            class="btn btn-primary"
                            v-bind:href="
                              context == 'booking' ? '#account' : '#terms'
                            "
                            >CONTINUE</a
                          >
                          <button
                            v-show="!rushSelected()"
                            class="btn btn-primary disabled"
                          >
                            CONTINUE
                          </button>
                        </center>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>

        <transition name="fade">
          <div id="account-view" v-show="current_view == 'account'">
            <div class="row" v-show="!user">
              <h5 class="accountFormHeaderBlue">NEW USERS</h5>
              <div class="col-xs-12">
                <center>
                  <h4 class="bookingHeader">Create an Account</h4>
                </center>
                <form class="form-horizontal">
                  <div class="form-group">
                    <label for="inputEmail3" class="col-xs-4 control-label"
                      >Email</label
                    >
                    <div class="col-xs-8">
                      <input
                        type="email"
                        class="form-control"
                        id="inputEmail3"
                        placeholder="student@example.com"
                        v-model="chosen.email"
                      />
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="inputPassword3" class="col-xs-4 control-label"
                      >Create Password</label
                    >
                    <div class="col-xs-8">
                      <input
                        type="password"
                        class="form-control"
                        id="inputPassword3"
                        placeholder="Password"
                        v-model="password"
                      />
                    </div>
                  </div>
                  <div class="form-group">
                    <label
                      for="inputPasswordAgain3"
                      class="col-xs-4 control-label"
                      >Re-type Password</label
                    >
                    <div class="col-xs-8">
                      <input
                        type="password"
                        class="form-control"
                        id="inputPasswordAgain3"
                        placeholder="Password"
                        v-model="passRetype"
                      />
                    </div>
                  </div>
                  <div class="form-group">
                    <center>
                      <button
                        type="submit"
                        class="btn btn-primary"
                        v-on:click.prevent="new_account_form()"
                      >
                        CONTINUE
                      </button>
                    </center>
                  </div>
                </form>
              </div>
            </div>

            <div class="row" v-show="!user">
              <h5 class="accountFormHeaderBlue">RETURNING USERS</h5>
              <div class="col-xs-12">
                <center><h4 class="bookingHeader">Log In</h4></center>
                <form class="form-horizontal">
                  <div class="form-group">
                    <label for="inputEmail4" class="col-xs-4 control-label"
                      >Email</label
                    >
                    <div class="col-xs-8">
                      <input
                        type="email"
                        class="form-control"
                        id="inputEmail4"
                        placeholder="student@example.com"
                        v-model="loginemail"
                      />
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="inputPassword4" class="col-xs-4 control-label"
                      >Password</label
                    >
                    <div class="col-xs-8">
                      <input
                        type="password"
                        class="form-control"
                        id="inputPassword4"
                        placeholder="Password"
                        v-model="loginpassword"
                      />
                      <a
                        class="pull-right"
                        v-on:click.prevent="user_forgot_password()"
                        >Forgot my Password</a
                      >
                    </div>
                  </div>
                  <div class="form-group">
                    <center>
                      <button
                        type="submit"
                        class="btn btn-primary"
                        v-on:click.prevent="user_login_check_token()"
                      >
                        LOG IN
                      </button>
                    </center>
                  </div>
                </form>
              </div>
            </div>

            <div class="row" v-show="user">
              <div class="col-xs-12">
                <h5 class="row accountFormHeaderBlue">
                  <span>LOGGED IN AS: </span>
                  <span> {{ chosen.email }}</span>
                  <a
                    class="pull-right"
                    style="padding-right: 10px"
                    v-on:click.prevent="user_logout()"
                  >
                    Not you?
                  </a>
                </h5>
                <div class="row form-group">
                  <center>
                    <br />
                    <button
                      type="submit"
                      class="btn btn-primary"
                      v-on:click.prevent="completeAccount()"
                    >
                      CONTINUE
                    </button>
                  </center>
                </div>
              </div>
            </div>
          </div>
        </transition>

        <transition name="fade">
          <div id="info-view" v-show="current_view == 'info'">
            <hr />

            <div class="row">
              <div class="col-xs-12">
                <form class="form-horizontal">
                  <div class="form-group">
                    <label class="col-xs-4 control-label"
                      >Student Last Name/ Surname</label
                    >
                    <div class="col-xs-8">
                      <input
                        type="text"
                        class="form-control"
                        placeholder=""
                        v-model="chosen.lastName"
                      />
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-xs-4 control-label"
                      >Student First Name</label
                    >
                    <div class="col-xs-8">
                      <input
                        type="text"
                        class="form-control"
                        placeholder=""
                        v-model="chosen.firstName"
                      />
                    </div>
                  </div>
                  <div class="form-group">
                    <label class="col-xs-4 control-label"
                      >Student Date of Birth</label
                    >
                    <div class="col-xs-3" style="padding-right: 5px">
                      <select class="form-control" v-model="chosen.birthyear">
                        <option value="">YYYY</option>
                        <option v-for="year in selectYears" v-bind:value="year">
                          {{ year }}
                        </option>
                      </select>
                    </div>
                    <div class="col-xs-2" style="padding: 0 5px">
                      <select class="form-control" v-model="chosen.birthmonth">
                        <option value="">MM</option>
                        <option
                          v-for="month in selectMonths"
                          v-bind:value="month"
                        >
                          {{ month }}
                        </option>
                      </select>
                    </div>
                    <div class="col-xs-2" style="padding: 0 5px">
                      <select class="form-control" v-model="chosen.birthdate">
                        <option value="">DD</option>
                        <option
                          v-for="day in daysInMonth(
                            chosen.birthyear,
                            chosen.birthmonth,
                          )"
                          v-bind:value="day"
                        >
                          {{ day }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <!--<div class="form-group">
                    <label class="col-xs-4 control-label">Student primary language</label>
                    <div class="col-xs-8">
                      <input type="text" class="form-control" placeholder="" v-model="reg.language">
                    </div>
                  </div>-->

                  <div class="form-group">
                    <label class="col-xs-4 control-label">Mobile Number</label>
                    <div class="col-xs-8">
                      <!-- 
                        <input type="tel" class="form-control mobile-input" placeholder="" id="mobile-user-info" v-model="chosen.cell" @input="validateMobile('#mobile-user-info')" @blur="validateMobile('#mobile-user-info')">
                        -->
                      <vue-tel-input
                        :defaultCountry="showRMB ? 'cn' : 'us'"
                        :disabledFetchingCountry="true"
                        :disabledFormatting="true"
                        v-model="chosen.cell"
                        :placeholder="''"
                        :enabledFlags="false"
                        :enabledCountryCode="false"
                        :preferredCountries="['ca', 'cn', 'in', 'kr', 'us']"
                        inputClasses="form-control"
                        :wrapperClasses="
                          chosen.cell && chosenBlurred && !chosenValid
                            ? 'has-error'
                            : ''
                        "
                        mode="international"
                        v-on:validate="chosenValid = $event.isValid"
                        v-on:country-changed="chosenCountry = $event"
                        v-on:blur="chosenBlurred = true"
                      >
                        <template v-slot:arrow-icon>
                          +{{ chosenCountry.dialCode }} {{ chosenCountry.iso2 }}
                          <span
                            class="glyphicon glyphicon-chevron-down"
                            style="margin-left: 4px"
                          ></span>
                        </template>
                      </vue-tel-input>
                    </div>
                  </div>

                  <div class="form-group">
                    <center>
                      <button
                        type="submit"
                        class="btn btn-primary"
                        v-on:click.prevent="completeInfo()"
                      >
                        CONTINUE
                      </button>
                    </center>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </transition>

        <transition name="fade">
          <div id="terms-view" v-show="current_view == 'terms'">
            <br />
            <div class="row">
              <center>
                <h4 class="notice">
                  <span class="glyphicon glyphicon-exclamation-sign"></span>
                  IMPORTANT TERMS OF USE
                </h4>
              </center>
              <!--  (服务条款) -->
            </div>

            <div class="row panel panel-default">
              <div class="panel-body">
                I agree (1) to the
                <a v-bind:href="env.serverAddr + '/terms_of_use/'"
                  >terms of use</a
                >
                and understand that this interview will be preserved for
                identity verification purposes, and (2) that if the person in
                the interview is different from the student who enrolls, I may
                have my student visa revoked.
                <!--
            <br/><br/>
            我同意（1）<a v-bind:href="env.serverAddr + '/terms_of_use/'">使用条款</a>，并且了解这次面试将被保存，并作为身份的验证；（2）如果面试中的人与录取的学生不是同一个人，我的学生签证将会被撤销。
            -->
              </div>
            </div>

            <div class="row panel panel-default">
              <div class="panel-body">
                <center>
                  <!-- <span class="glyphicon glyphicon-ok" v-show="this.sayYesToAgree.toUpperCase() === 'YES'"></span> -->
                  <span>Type "Yes" if you agree: </span>
                  <input
                    style="margin-left: 10px; width: 60px; display: inline"
                    type="text"
                    class="form-control"
                    v-model="sayYesToAgree"
                  />
                </center>
              </div>
            </div>

            <div class="row">
              <center>
                <button
                  class="btn btn-default"
                  v-show="sayYesToAgree == null"
                  v-on:click.prevent="goBackToInfo()"
                >
                  GO BACK
                </button>
                <button
                  class="btn btn-primary"
                  v-show="sayYesToAgree != null"
                  v-on:click.prevent="completeTerms()"
                >
                  CONTINUE
                </button>
              </center>
            </div>
          </div>
        </transition>

        <transition name="fade">
          <div id="summary-view" v-show="current_view == 'summary'">
            <div class="row panel panel-default">
              <div class="panel-body">
                <div class="row">
                  <!-- <a class="edit-button" href="#" v-on:click.prevent="goToHash('type','summary')">Edit Interview Type</a> -->
                  <div class="col-xs-5 fieldTitle">APPLYING FOR:</div>
                  <div class="col-xs-7 fieldValue">
                    {{ chosen.applyingFor }}
                  </div>
                </div>
                <!--<div class="row">
                    <div class="col-xs-5 fieldTitle">TYPE:</div><div class="col-xs-7 fieldValue">{{ asessement_type }}</div>
                </div>-->

                <div class="row" v-show="chosen.type.v == 1">
                  <div class="col-xs-5 fieldTitle">TIME ZONE:</div>
                  <div class="col-xs-7 fieldValue">{{ chosen.locTzName }}</div>
                </div>
                <div class="row" v-show="chosen.type.v == 2">
                  <div class="col-xs-5 fieldTitle">CITY:</div>
                  <div class="col-xs-7 fieldValue">{{ chosen.locCity }}</div>
                </div>

                <div class="row">
                  <div class="col-xs-5 fieldTitle">DATE & TIME:</div>
                  <div class="col-xs-7 fieldValue">
                    {{ computeLocalDate }} <br />{{ computeLocalTime }}
                    <a
                      v-if="context == 'booking' || context == 'reschedule'"
                      class="edit-button"
                      href="#"
                      v-on:click.prevent="goToHash('time', 'summary')"
                      ><span class="glyphicon glyphicon-pencil"></span></a
                    ><br /><span class="orangeNote"
                      >(pending completion of payment)</span
                    >
                  </div>
                </div>
                <!-- <div class="row">
                    <div class="col-xs-5 fieldTitle">RECEIVE INTERVIEW BY:</div><div class="col-xs-7 fieldValue">{{ computeLocalProcessingDate(chosen.rushID) }} <a v-if="!couponIsPsp" class="edit-button" href="#" v-on:click.prevent="goToHash('rush', 'summary')"><span class="glyphicon glyphicon-pencil"></span></a><br/><span class="orangeNote">(assuming student materials are provided in a timely fashion)</span></div>
                </div> -->
                <div class="row">
                  <div class="col-xs-5 fieldTitle">NAME:</div>
                  <div class="col-xs-7 fieldValue">
                    {{ chosen.lastName }}, {{ chosen.firstName }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-5 fieldTitle">BIRTHDATE:</div>
                  <div class="col-xs-7 fieldValue">
                    {{ chosen.birthyear }}-{{ chosen.birthmonth }}-{{
                      chosen.birthdate
                    }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-5 fieldTitle">EMAIL:</div>
                  <div class="col-xs-7 fieldValue">{{ chosen.email }}</div>
                </div>
                <div class="row">
                  <div class="col-xs-5 fieldTitle">MOBILE NUMBER:</div>
                  <div class="col-xs-7 fieldValue">{{ chosen.cell }}</div>
                </div>
                <div class="row">
                  <div class="col-xs-5 fieldTitle">TOTAL AMOUNT DUE:</div>
                  <div class="col-xs-7 fieldValue">
                    {{ computeTotalPriceDisplay }}
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-5" v-if="context == 'booking'">
                    <center>
                      <button
                        class="btn btn-default"
                        v-on:click.prevent="goToHash('info', 'summary')"
                      >
                        EDIT INFO
                      </button>
                    </center>
                  </div>
                  <div
                    v-bind:class="{
                      'col-xs-7': context == 'booking',
                      'col-xs-12': context != 'booking',
                    }"
                  >
                    <div v-bind:class="{ 'text-center': context != 'booking' }">
                      <button
                        class="btn btn-primary"
                        v-on:click.prevent="completeSummary()"
                      >
                        SAVE AND CONTINUE
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>

        <transition name="fade">
          <div id="policy-view" v-show="current_view == 'policy'">
            <div class="row">
              <h4 class="notice">Refund & Change Policy</h4>
            </div>

            <div class="row">
              <div class="panel panel-default">
                <div class="panel-body">
                  We're about to
                  <span v-if="context == 'booking'"
                    >send a payment link to your email.</span
                  >
                  <span v-if="context == 'reschedule'"
                    >give you a link to our payment system to reschedule your
                    interview.</span
                  >
                  <span v-if="context == 'rushprocessing'"
                    >give you a link to our payment system to process your
                    interview faster.</span
                  >
                  <br />Please note your payment is NOT refundable.
                  <span v-if="context == 'booking'">
                    <br /><br />All requests to change times will require a
                    service charge of
                    {{ itemTypes.itemsUSD.SERVICE_RESCHEDULE }} USD ({{
                      itemTypes.itemsRMB.SERVICE_RESCHEDULE
                    }}
                    RMB). Any request must be made at least three days in
                    advance of the originally scheduled time. <br /><br />If
                    this is your second interview, please note: Your most recent
                    interview becomes the only interview you can send to
                    admission officers. You cannot do the interview twice and
                    then elect to send the first one.
                  </span>
                </div>
              </div>
            </div>
            <!--
        <div class="row">
            <div class="panel panel-default">
                <div class="panel-body">
                    <span v-if="context == 'booking'">
                        你的面试费用不能退款！<br/>
                        请注意：面试预约之后，面试者如果需要更改面试时间或地点，需要在原本的面试时间前至少提前3天提出申请，每次更改需要加收
                        {{itemTypes.itemsUSD.SERVICE_RESCHEDULE}}美元（{{itemTypes.itemsRMB.SERVICE_RESCHEDULE}}人民币）费用。请再次确认你所选择的面试时间和地点。<br/>如果这是你的二次面试，请注意：你只能发送最后的一次面试给招生官，不能在两次面试中择优而发。
                    </span>
                    <span v-if="context == 'reschedule'">
                        我们将会提供您一个改面试时间的支付链接。
                        <br/>请注意，成功支付的费用不可退还。
                    </span>
                    <span v-if="context == 'rushprocessing'">
                        我们将会提供您一个办理加急制作面试的支付链接。
                        <br/>请注意，成功支付的费用不可退还。
                    </span>
                </div>
            </div>
        </div>
        -->

            <div class="row panel panel-default">
              <div class="panel-body">
                <center>
                  <!-- <span class="glyphicon glyphicon-ok" v-show="this.sayYesToAgreePolicy.toUpperCase() === 'YES'"></span> -->
                  <span>Type "Yes" if you agree: </span>
                  <input
                    style="margin-left: 10px; width: 60px; display: inline"
                    type="text"
                    class="form-control"
                    v-model="sayYesToAgreePolicy"
                  />
                </center>
              </div>
            </div>

            <div class="row">
              <center>
                <button
                  class="btn btn-primary"
                  v-show="sayYesToAgreePolicy != null"
                  v-on:click.prevent="completePolicy()"
                >
                  <span v-if="context == 'booking'"
                    >Send Email Confirmation</span
                  ><span v-if="context != 'booking'">Get Payment Link</span>
                </button>
              </center>
              <center>
                <button
                  class="btn btn-default"
                  v-show="sayYesToAgreePolicy == null"
                  v-on:click.prevent="goNext('summary')"
                >
                  Go Back
                </button>
              </center>
            </div>
          </div>
        </transition>

        <transition name="fade">
          <div id="payment-view" v-show="current_view == 'payment'">
            <br />
            <div class="row">
              <h4 class="notice">Continue to Payment</h4>
              <div class="panel panel-default">
                <div class="panel-body">
                  <p>
                    Click here to complete your payment:
                    <a v-bind:href="payment_url" target="_blank">{{
                      payment_url
                    }}</a>
                  </p>
                  <span v-if="context == 'reschedule'">
                    <p>
                      Please click on this link right away and pay within 30
                      minutes to reserve the new time you have requested. If you
                      do not pay within 30 minutes, your interview will not be
                      rescheduled and will remain at the original time you
                      chose.
                    </p>
                    <p>
                      You will receive a confirmation email when your request is
                      confirmed. If you do not receive a confirmation email,
                      please call (+86-10-8286-3889) or email
                      contact@initialview.com. Your rescheduling request is NOT
                      confirmed if you do not have a confirmation email.
                    </p>
                    <!--
                        <p>此链接30分钟内有效，请尽快点击链接，完成付费。如果您在30分钟内没有付费，您的面试将会保留原来的预约时间。</p>
                        <p>您的面试更改请求通过后，我们会向您的邮箱发送一封确认邮件。如果您没有收到确认邮件，请致电+86-10-82863889，或发邮件至contact@initialview.com。面试更改是否成功，将以最终收到的确认信为准。</p>
                        -->
                  </span>
                  <span v-if="context == 'rushprocessing'">
                    <p>
                      Please click on this link right away and pay within 30
                      minutes to have your interview processed faster. If you do
                      not pay within 30 minutes, your interview processing time
                      will remain at the option you originally chose.
                    </p>
                    <!--
                        <p>此链接30分钟内有效，请尽快点击链接，完成付费。如果您在30分钟内没有付费，您的面试制作完成时间将不会改变。</p>
                        -->
                  </span>
                  <div class="text-center">
                    <p>
                      When you're done, click here to return to the Student
                      Portal.
                    </p>
                    <!--
                        <p>当您完成付费后，请点击下方按钮回到你的个人主页</p>
                        -->
                    <div class="btn btn-default" v-on:click="paymentFinished()">
                      Close this window and check your email
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>

        <transition name="fade">
          <div id="email-view" v-show="current_view == 'email'">
            <br />
            <div class="row">
              <h4 class="notice">Email Verification Sent</h4>
              <div class="panel panel-default">
                <div class="panel-body">
                  <p>
                    An email was sent to: <b>{{ chosen.email }}</b>
                  </p>
                  <p>
                    Please check your email right away and pay within 30 minutes
                    to reserve your time. Your time is not reserved until you
                    pay. If you do not pay within 30 minutes, you will have to
                    log back in and choose your time again. <br /><br />Please
                    follow the verification and payment instructions in the
                    email to complete your booking. If you do not see the email,
                    please check your spam box. <br /><br />If you need help,
                    please email: contact@initialview.com
                  </p>
                </div>
              </div>
              <!--
            <div class="panel panel-default">
                <div class="panel-body">
                    <p>我们发送了一封邮件到：<b>{{chosen.email}}</b></p>
                    <p>请在邮箱中查看支付信息，并在30分钟内完成支付。支付完成即可预约成功。若在30分钟内未能完成支付，请重新选择时间再次预约。<br/><br/>请仔细阅读邮件需要确认和支付的内容，并按照要求预约并完成支付。未收到支付邮件，请注意查看垃圾邮箱。<br/><br/>如需帮助，请联系 contact@initialview.com.</p>
                </div>
            </div>
            --></div>
          </div>
        </transition>

        <transition name="fade">
          <div id="bookfail-view" v-show="current_view == 'bookfail'">
            <br />
            <div class="row">
              <h4 class="notice">Booking Error</h4>
              <div class="panel panel-default">
                <div class="panel-body">
                  <p>Oops! Something is not quite right.</p>
                  <p>Here are a few things to check:</p>
                  <p>Are you logged in already?</p>
                  <p>
                    Do you have another pending reservation that you haven’t
                    paid for yet?
                  </p>
                  <p>
                    Have you already booked another time within 14 days? (you
                    can only do one interview every 14 days, so make sure to
                    choose a time accordingly.
                    <a
                      v-if="context == 'booking'"
                      v-on:click.prevent="goNext('splash')"
                      >Please trying signing up for a different time</a
                    >
                    <a
                      v-if="context == 'reschedule'"
                      v-on:click.prevent="goNext('time')"
                      >Please trying signing up for a different time</a
                    >
                    ).
                  </p>
                  <p>
                    <a v-bind:href="env.serverAddr + '/faqs'"
                      >See our FAQs if you have questions about our rules.</a
                    >
                  </p>
                  <p>
                    Still having issues? <br /><a
                      style="color: #4f6892"
                      href="mailto:contact@initialview.com"
                      >Please email us at contact@initialview.com</a
                    >
                    <br />or give us a call at +86-10-8286-3889 <br />or
                    +1-833-378-3886 if you have questions.
                  </p>
                </div>
              </div>
              <!-- chinese version -->
              <!-- <div class="panel panel-default">
                <div class="panel-body">
                    <p></p>
                </div>
            </div> -->
            </div>
          </div>
        </transition>

        <!-- <div id="pay-view" v-show="current_view == 'locationTz'">
        <br/>
        <div class="row">
            <center><h4> {{content.pay.notice}}</h4></center>
        </div>

        <div class="row">
            <div class="col-xs-12">{{{content.pay.language}}}</div>
        </div>

        <br/>
        <div class="row">
            <center><button class="btn btn-primary" v-on:click.prevent="completePay()">Skip to Success!</button></center>
        </div>
    </div>

    <div id="success-view" v-show="current_view == 'locationTz'">
        <br/>
        <div class="row">
            <center><h4> {{content.success.notice}}</h4></center>
        </div>

        <br/>
        <div class="row">
            <center><button class="btn btn-primary" v-on:click.prevent="completeSuccesss()">{{content.success.submitButton}}</button></center>
        </div>
    </div> -->
      </div>
      <!-- end of container -->
    </div>
    <!-- end of vue container -->
  </div>
</template>

<script>
import Vue from "vue";
import VueResource from "vue-resource";
Vue.use(VueResource);
import Spinner from "@/components/Spinner.vue";
import Alert from "@/components/Alert.vue";
import {
  ivAlertMixin,
  ivSpinnerMixin,
  ivUserAccountMixin,
  ivModalMixin,
  ivUserInfoMixin,
  getParameterByName,
  ivbus,
  apiClient,
  setEnv,
} from "iv-base-components";

import env from "@/utils/env.js";
setEnv(env);

import moment from "moment-timezone";
// const clndr = require('clndr');
import clndr from "@/components/clndr.js";
import NavTools from "@/components/NavTools.vue";
import "@/components/datepicker/js/bootstrap-datepicker.min.js";
// import from "/code/s/staticlib/ioncalendar/js/ion.calendar.js";
import intlTelInput from "@/components/intl-tel-input/js/intlTelInput.min.js";
// import "/code/s/staticlib/alertify/js/alertify.js";

import jQuery from "jquery";

import { VueTelInput } from "vue-tel-input";
// import 'vue-tel-input/dist/vue-tel-input.css'

//CALENDAR

var bookingClndr = null;

export default {
  mixins: [
    ivUserInfoMixin,
    ivSpinnerMixin,
    ivAlertMixin,
    ivModalMixin,
    ivUserAccountMixin,
  ],

  components: {
    VueTelInput,
    Alert,
    Spinner,
    NavTools,
  },
  data() {
    return {
      env: env,
      ////session management

      //login
      loginpassword: "",
      loginemail: "",

      //get rid of this as soon as logged in
      password: "",
      passRetype: "",

      ////

      context: "booking", // or "reschedule" or "rushprocessing"

      current_view: "main",
      headers: {
        main: "What do you need to schedule?",
        splash: "What do you need to schedule?",
        type: "What do you need to schedule?",
        locationCity: "Where would you like to take the assessment?",
        locationTz: "In which time zone will you be taking the assessment?",
        time: "Select your assessment date and time",
        details: "Your Assessment Details",
        rush: "Select your processing time",
        account: " ",
        info: "Student Information",
        terms: " ",
        summary: "Please make sure the following information is correct",
        policy: " ",
        payment: " ",
        email: " ",
        bookfail: " ",
      },

      categoryList: [
        {
          v: 1,
          textValue: "Webcam",
          image: "/components/img/booking/online.png",
          title: "GLOBAL ASSESSMENT",
          subtitle: "offered online in all countries",
        },
      ],

      typeList: [],

      locationCityHeadings: [],
      locationCityList: [],

      locationTzHeadings: [],
      locationTzList: [],

      timeList: [],

      rushList: [],
      rushableList: [],

      reg: {
        timezone: {
          timezone: "",
        },
        email: "",
        firstname: "",
        lastname: "",
        birthday: "",
        cell: "",
        grade: "",
        language: "",
        datetime: "",
      },

      asessement_type: "",

      chosen: {
        type: {
          v: 1,
          textValue: "Webcam",
        },
        applyingFor: "Undergraduate",
        iv_type: "college",
        priceRMB: "N/A",
        priceUSD: "N/A",
        locCity: "Incomplete",
        locTzName: "Incomplete",
        locTz: "Asia/Shanghai",
        utc: "1600-01-01T00:00:00+0000",
        rushID: 0,
        rushProcessingDays: 10,
        rushPriceRMB: 0,
        rushPriceUSD: 0,
        email: null,
        emailPersonal: null,
        lastName: null,
        firstName: null,
        birthyear: "",
        birthmonth: "",
        birthdate: "",
        cell: null,
        coupon: "mulgrav",
        couponValid: true,
        termsAgree: false,
        invite: null,
        timeSlotTag: null,
        onlyTagged: false, //when false, all un-tagged timeslots will show
      },

      chosenValid: false,
      chosenCountry: "",
      chosenBlurred: false,

      // //for fast testing
      // chosen: {
      //   type: {
      //       v: 1,
      //       textValue: "None Selected"
      //   },
      //   applyingFor: 'College',
      //   iv_type:'college',
      //   priceRMB: 'N/A',
      //   priceUSD: 'N/A',
      //   locCity: 'online',
      //   locTzName: 'Beijing',
      //   locTz:'Asia/Shanghai',
      //   utc: 'N/A',
      //   email: 'simple@example.com',
      //   emailPersonal: '',
      //   lastName: 'simple',
      //   firstName: 'sim',
      //   birthdate: '1992-04-02',
      //   cell: '1294949992954',
      //   coupon: null,
      //   couponValid: false,
      //   termsAgree: true
      // },

      //for a 20% discount put 0.8
      couponMultiplyer: 0.7,
      couponIsPsp: false,
      rush_only: false,

      slots: [],

      clndrDay: "",
      clndrMonth: "",

      uiReturn: null,
      uiFadeTime: 600,

      //type yes to agree
      sayYesToAgree: null,
      sayYesToAgreePolicy: null,

      browser: {
        timezone: moment.tz.guess(),
      },

      selectYears: Array.from(Array(100).keys()).map(function (i) {
        return moment().year() + 1 - i + "";
      }),
      selectMonths: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ],
      selectDays: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23",
        "24",
        "25",
        "26",
        "27",
        "28",
        "29",
        "30",
        "31",
      ],

      requestDefault: "",

      request: {
        date: "",
        name: "",
        email: "",
        phone: "",
        reason: "",
      },
      mobile: "",
      requestValid: true,
      requestBlurred: false,
      requestCountry: "",

      requestLoading: false,
      requestFailed: false,

      currentTimeoutId: null,

      modalHiddenEventEnabled: true,
      saExistsMessage: false,

      loginAttempt: false,

      // clndr
      daysOfTheWeek: null,
      numberOfRows: null,
      months: null,
      days: null,
      month: null,
      year: null,
      eventsThisMonth: null,
      eventsLastMonth: null,
      eventsNextMonth: null,
      extras: null,

      booking_id: null,
      payment_url: null,
      rushability: 0,
      reschedule: {},
      custom_prices_loaded: false,

      spinconfig: {
        key: "booking",
      },
      configuring: false,

      itemTypes: {
        itemsRMB: {
          SERVICE_INTERVIEW_AND_WRITING: "",
          SERVICE_INTERVIEW: "",
          SERVICE_TEN_TO_FIVE_DAY_RUSH: "",
          SERVICE_FIVE_TO_TWO_DAY_RUSH: "",
          SERVICE_RESCHEDULE: "",
          SERVICE_CUSTOM_CHARGE: "",
          SERVICE_OTIS: "",
          SERVICE_30FOR30: "",
          SERVICE_GAOKAO: "",
          SERVICE_CSAT: "",
          SERVICE_SUMMER: "",
        },
        itemsUSD: {
          SERVICE_INTERVIEW_AND_WRITING: "",
          SERVICE_INTERVIEW: "",
          SERVICE_TEN_TO_FIVE_DAY_RUSH: "",
          SERVICE_FIVE_TO_TWO_DAY_RUSH: "",
          SERVICE_RESCHEDULE: "",
          SERVICE_CUSTOM_CHARGE: "",
          SERVICE_OTIS: "",
          SERVICE_30FOR30: "",
          SERVICE_GAOKAO: "",
          SERVICE_CSAT: "",
          SERVICE_SUMMER: "",
        },
      },
    };
  },
  computed: {
    showRMB() {
      return window.location.hostname.indexOf("cn") > -1;
    },
    filteredTimeslots: function () {
      var that = this;
      return this.timeList.filter(
        function (t) {
          return t.date.indexOf(that.clndrDay) > -1;
        }.bind(that),
      );
    },
    computePriceRMB: function () {
      if (this.context == "reschedule") {
        return this.reschedule.priceRMB;
      }
      if (this.context == "rushprocessing") {
        return 0;
      }

      var appForFind = this.chosen.iv_type;
      var temp = this.typeList.filter(function (thing) {
        return thing.v == appForFind;
      });
      var p = temp.length > 0 ? temp[0] : {};
      if (this.chosen.couponValid) {
        var newRMB = Number((p.priceRMB * this.couponMultiplyer).toFixed(2));
        return newRMB;
      } else {
        return p.priceRMB;
      }
    },
    computePriceUSD: function () {
      if (this.context == "reschedule") {
        return this.reschedule.priceUSD;
      }
      if (this.context == "rushprocessing") {
        return 0;
      }

      var appForFind = this.chosen.iv_type;
      var temp = this.typeList.filter(function (thing) {
        return thing.v == appForFind;
      });
      var p = temp.length > 0 ? temp[0] : {};
      if (this.chosen.couponValid) {
        var newUSD = Number((p.priceUSD * this.couponMultiplyer).toFixed(2));
        return newUSD;
      } else {
        return p.priceUSD;
      }
    },

    computePriceDisplay: function () {
      return (
        this.computePriceUSD + " USD " + "(" + this.computePriceRMB + " RMB)"
      );
    },

    computeTotalPriceRMB: function () {
      return this.chosen.rushPriceRMB + this.computePriceRMB;
    },

    computeTotalPriceUSD: function () {
      return this.chosen.rushPriceUSD + this.computePriceUSD;
    },

    computeTotalPriceDisplay: function () {
      return (
        this.computeTotalPriceUSD +
        " USD " +
        "(" +
        this.computeTotalPriceRMB +
        " RMB)"
      );
    },

    computePercent: function () {
      return ((1 - this.couponMultiplyer) * 100).toFixed(0);
    },

    computeLocalDate: function () {
      if (this.chosen.utc) {
        return moment(this.chosen.utc)
          .tz(this.chosen.locTz)
          .format("MMMM D, YYYY");
      } else {
        return null;
      }
    },

    computeLocalTime: function () {
      if (this.chosen.utc) {
        return moment(this.chosen.utc).tz(this.chosen.locTz).format("h:mm A");
      } else {
        return null;
      }
    },
  },
  created: function () {
    var that = this;
    apiClient
      .get("/api/interview/payment/product_info_map/")
      .then(function (response) {
        if (response.data.status == 200) {
          Vue.set(that, "itemTypes", response.data.data);
        }
      })
      .catch(function (error) {
        that.showMessage(
          "Please refresh the page to try again!  If the problem persists, please e-mail us at contact@initialview.com.",
          "alert-danger",
          that.uiMessageWaitLong,
        );
      });
    //// NAVIGATION ////

    // // //FOR TESTING view manager
    // var requestHash = location.hash.slice(1);
    // if (requestHash == "") {
    //     location.hash = "splash";
    // } else {
    //     location.hash = "";
    //     location.hash = requestHash;
    // }
    // //FOR TEST END

    // //FOR PROD
    // //clear and set
    var that = this;
    location.hash = "";
    location.hash = "splash";
    // //FOR PROD END

    console.log(getParameterByName("i"));
    var pinvite = getParameterByName("i");
    if (pinvite != null) {
      Vue.set(that.chosen, "invite", pinvite);
    }

    console.log(getParameterByName("t"));
    //This parameter requests that timeslots with this tag
    // be added to the return data
    var t = getParameterByName("t");
    if (t != null) {
      Vue.set(that.chosen, "timeSlotTag", t);

      console.log(getParameterByName("x"));
      //This parameter, when = 1, removes all un-tagged timeslots
      var x = getParameterByName("x");
      if (x != null) {
        Vue.set(that.chosen, "onlyTagged", x);
      } else {
        Vue.set(that.chosen, "onlyTagged", 1);
      }

      that.applyTag();
    }

    console.log(getParameterByName("c"));
    var pcoup = getParameterByName("c");
    if (pcoup != null) {
      Vue.set(that.chosen, "coupon", pcoup);
      // that.checkCoupon();
    }

    $(window).on("hashchange", function () {
      that.closeModal("myModal");
      that.closeModal("emptyMonthModal");
      that.closeModal("requestTimeModal");
      that.closeModal("afterTimeRequestModal");
      window.clearTimeout(that.currentTimeoutId);

      var new_view = location.hash.slice(1);
      if (that.headers[new_view]) {
        that.current_view = new_view;
      } else {
        that.current_view = "splash";
      }
    });

    // bind clndr to the left and right arrow keys
    $(document).keydown(function (e) {
      if (that.current_view == "time" && (e.keyCode == 37 || e.keyCode == 39)) {
        that.closeModal("emptyMonthModal");

        var setNewMonth = function () {
          Vue.set(that, "clndrMonth", bookingClndr.month.format("MMMM YYYY"));
          window.clearTimeout(that.currentTimeoutId);
          var timeoutId = window.setTimeout(function () {
            Vue.set(that, "currentTimeoutId", null);
            console.log(bookingClndr.month.format("MMMM YYYY"));
            if (that.isEmptyMonth(bookingClndr.month)) {
              that.showEmptyMonthModal();
            }
          }, 1000);
          Vue.set(that, "currentTimeoutId", timeoutId);
          console.log("current timeout id: " + timeoutId);
        };

        if (e.keyCode == 37) {
          // left arrow
          //bookingClndr.back();
          bookingClndr.month = bookingClndr.previous().month;
          setNewMonth();
        }
        if (e.keyCode == 39) {
          // right arrow
          //bookingClndr.forward();
          bookingClndr.month = bookingClndr.next().month;
          setNewMonth();
        }
      }
    });
  },
  mounted: function () {
    var that = this;
    window.jQuery = $;
    window.$ = $;

    ivbus.getFlagSticky("user", function (user) {
      if (user) {
        // login event
        if (that.couponIsPsp) {
          that.callBookingApi();
        }

        that.chosen.email = user.email;
        that.chosen.lastName = user.last_name;
        that.chosen.firstName = user.first_name;
        var arrBirthday = user.birthday.split("-");
        that.chosen.birthyear = arrBirthday[0];
        that.chosen.birthmonth = arrBirthday[1];
        that.chosen.birthdate = arrBirthday[2];
        that.chosen.cell = user.cell;
      } else {
        // logout event
        if (that.loginAttempt) {
          that.loginAttempt = false; // this codepath is to keep the user on the registration page if they're an existing user but typed their password incorrectly
          return;
        }

        that.fetchUser(); // this will reset this.user and trigger the redirect-to-login on loginRequired pages

        that.chosen.email = "";
        that.chosen.lastName = "";
        that.chosen.firstName = "";
        that.chosen.birthyear = "";
        that.chosen.birthmonth = "";
        that.chosen.birthdate = "";
        that.chosen.cell = "";

        that.goNext("splash");
      }
    });

    that.fetchProductInfo();

    ivbus.getFlagSticky("booking-initialization", function (config) {
      var spinId = that.spinStart();
      that.configuring = true;
      console.log("booking initialized");
      that.context = config.context;
      that.booking_id = config.booking_id;
      that.rushability = config.rushability;

      Vue.set(that, "chosen", config.chosen);

      // for Processing, rushableList is based on your rushability
      // rushability = null => rushableList = []
      // rushability = 0 => rushableList = rushlist = [0, 1, 2]
      // rushability = 1 => rushableList = [1, 2]
      // rushability = 2 => rushableList = [2]

      // for Reschedule, rushableList is based on what you've already purchased
      // keep waht you have, or upgrade
      // have = 0 => rushableList = [0, 1, 2]
      // have = 1 => rushableList = [1, 2]
      // have = 2 => rushableList = [2]

      apiClient
        .get(
          "/api/interview/payment/product_info_mulgrave_iv_ws/?bid=" +
            that.booking_id,
        )
        .then(function (response) {
          that.custom_prices_loaded = true;
          that.typeList = response.data.data.typelist;
          that.rushList = response.data.data.processinglist;
          that.rushableList = that.rushList;
          if (that.context == "reschedule") {
            that.rushableList = that.rushList.filter(function (r) {
              return r.id >= that.chosen.rushID;
            });
            if (that.chosen.type.v == 1) {
              that.goNext("locationTz");
            } else {
              that.fetchCalendarEvents();
              that.goNext("time");
            }
          }
          if (that.context == "rushprocessing") {
            that.rushableList = that.rushList.filter(function (r) {
              return that.rushability !== null && r.id >= that.rushability;
            });
            that.goNext("rush");
          }
          that.reschedule = response.data.data.reschedule;
          that.chosen.applyingFor = that.typeList.filter(function (type) {
            return type.v == that.chosen.iv_type;
          })[0].title;
          that.spinStop(spinId);
          that.configuring = false;
        })
        .catch(function (error) {
          that.spinStop(spinId);
          that.showMessage(
            "Please refresh the page to try again!  If the problem persists, please e-mail us at contact@initialview.com.",
            "alert-danger",
            that.uiMessageWaitLong,
          );
        });
    });

    var spinId = that.spinStart();
    apiClient
      .get("/api/interview/timezones/")
      .then(function (response) {
        that.spinStop(spinId);
        var sectionedTzList = {};
        var headings = [];
        response.data.timezones.forEach(function (tz) {
          var section = tz.timezone.split("/")[0];
          if (sectionedTzList[section] === undefined) {
            headings.push(section);
            sectionedTzList[section] = {
              section: section,
              list: [],
            };
          }
          sectionedTzList[section].list.push(tz);
        });
        Vue.set(that, "locationTzHeadings", headings.sort());
        Vue.set(that, "locationTzList", sectionedTzList);
      })
      .catch(function (error) {
        that.spinStop(spinId);
        that.showMessage(
          "Please refresh the page to try again!  If the problem persists, please e-mail us at contact@initialview.com.",
          "alert-danger",
          that.uiMessageWaitLong,
        );
      });

    var spinId2 = that.spinStart();
    apiClient
      .get("/api/interview/locations/")
      .then(function (response) {
        that.spinStop(spinId2);
        if (response.data.status == 200) {
          var sectionedLocationList = {};
          var headings = [];
          response.data.data.forEach(function (city) {
            if (sectionedLocationList[city.country] === undefined) {
              headings.push(city.country);
              sectionedLocationList[city.country] = {
                country: city.country,
                list: [],
              };
            }
            sectionedLocationList[city.country].list.push(city);
          });
          Vue.set(that, "locationCityHeadings", headings.sort());
          Vue.set(that, "locationCityList", sectionedLocationList);
        }
      })
      .catch(function (error) {
        that.spinStop(spinId2);
        that.showMessage(
          "Please refresh the page to try again!  If the problem persists, please e-mail us at contact@initialview.com.",
          "alert-danger",
          that.uiMessageWaitLong,
        );
      });

    // initialize clndr
    bookingClndr = $("#booking-clndr").clndr({
      forceSixRows: true,
      constraints: {
        startDate: moment().format("YYYY-MM-DD"),
        endDate: moment().add(12, "months").format("YYYY-MM-DD"),
      },
      clickEvents: {
        click: function (target) {
          that.pickDay(target.date);
          $(".day-wrapper").removeClass("day-selected");
          $(target.element).children().addClass("day-selected");
          console.log("current timeout id: " + that.currentTimeoutId);
          if (
            that.currentTimeoutId == null ||
            !that.isEmptyMonth(bookingClndr.month)
          ) {
            that.showDayModal();
          }
        },
        nextMonth: function () {
          console.log("next month.");
        },
        previousMonth: function () {
          console.log("previous month.");
        },
        onMonthChange: function (month) {
          console.log("month changed.");
          //check for blank month
          Vue.set(that, "clndrMonth", month.format("MMMM YYYY"));
          window.clearTimeout(that.currentTimeoutId);
          var timeoutId = window.setTimeout(function () {
            Vue.set(that, "currentTimeoutId", null);
            if (that.isEmptyMonth(bookingClndr.month)) {
              that.showEmptyMonthModal();
            }
          }, 1000);
          Vue.set(that, "currentTimeoutId", timeoutId);
          console.log("current timeout id: " + timeoutId);
        },
        nextYear: function () {
          console.log("next year.");
        },
        previousYear: function () {
          console.log("previous year.");
        },
        onYearChange: function () {
          console.log("year changed.");
        },
      },
      events: [],
      multiDayEvents: {
        startDate: "startDate",
        endDate: "endDate",
        singleDay: "date",
      },
      render: function (data) {
        // put data on vm
        that.daysOfTheWeek = data.daysOfTheWeek;
        that.numberOfRows = data.numberOfRows;
        that.months = data.months;
        that.days = data.days;
        that.month = data.month;
        that.year = data.year;
        that.eventsThisMonth = data.eventsThisMonth;
        that.eventsLastMonth = data.eventsLastMonth;
        that.eventsNextMonth = data.eventsNextMonth;
        that.extras = data.extras;

        return $("#booking-clndr-template").html();
      },
      showAdjacentMonths: true,
      adjacentDaysChangeMonth: false,
      doneRendering: function () {
        console.log("done rendering.");
      },
    });
  },

  methods: {
    contains: function (array, prop, value) {
      return (
        array.filter(function (item) {
          return item[prop] == value;
        }).length > 0
      );
    },

    daysInMonth: function (year, month) {
      if (
        month == "01" ||
        month == "03" ||
        month == "05" ||
        month == "07" ||
        month == "08" ||
        month == "10" ||
        month == "12"
      )
        return this.selectDays.slice(0, 31);
      if (month == "04" || month == "06" || month == "09" || month == "11")
        return this.selectDays.slice(0, 30);
      if (month == "02") {
        if (year % 4 == 0) return this.selectDays.slice(0, 29);
        else return this.selectDays.slice(0, 28);
      }
    },

    timesForDay: function (times, day) {
      return times
        .filter(function (time) {
          return time.date == day;
        })
        .sort(function (a, b) {
          return a.utc < b.utc ? -1 : a.utc > b.utc ? 1 : 0;
        });
    },

    fetchProductInfo: function () {
      var that = this;
      var spinId = that.spinStart();
      apiClient
        .get("/api/interview/payment/product_info_mulgrave_iv_ws/")
        .then(function (response) {
          that.spinStop(spinId);
          if (that.custom_prices_loaded) return;
          that.typeList = response.data.data.typelist;
          that.rushList = response.data.data.processinglist; // TODO: filter this by rushability
          that.rushableList = that.rushList;
          if (that.context == "reschedule") {
            that.rushableList = that.rushList.filter(function (r) {
              return r.id >= that.chosen.rushID;
            });
          }
          if (that.context == "rushprocessing") {
            that.rushableList = that.rushList.filter(function (r) {
              return that.rushability !== null && r.id >= that.rushability;
            });
          }
          that.reschedule = response.data.data.reschedule;
        })
        .catch(function (error) {
          that.spinStop(spinId);
          that.showMessage(
            "Please refresh the page to try again! If the problem persists, please email us at contact@initialview.com.",
            "alert-danger",
            that.uiMessageWaitLong,
          );
        });
    },

    rushSelected: function () {
      var that = this;
      return (
        this.rushableList.filter(function (r) {
          return r.id == that.chosen.rushID;
        }).length > 0
      );
    },

    computeLocalProcessingDate: function (rushId) {
      if (!this.rushList.length) return;
      var days = this.rushList.filter(function (r) {
        return r.id == rushId;
      })[0].processingDays;
      var date = moment(Math.max(moment(), moment(this.chosen.utc)));
      date = date.tz("Asia/Shanghai");
      if (date.hour() < 12) {
        date.subtract(1, "days");
      }
      date = date.hour(20);
      while (days > 0) {
        date = date.add(1, "days");
        // decrease "days" only if it's a weekday.
        if (date.isoWeekday() !== 6 && date.isoWeekday() !== 7) {
          days -= 1;
        }
      }
      return date.tz(this.chosen.locTz).format("MMMM D, YYYY");
    },

    new_account_form: function () {
      var that = this;
      if (this.password.length < 15) {
        that.showMessage(
          "Password must be at least 15 characters.",
          "alert-warning",
          that.uiMessageWaitLong,
        );
        return;
      }
      if (this.passRetype == this.password && this.password != "") {
        var spinId = that.spinStart();
        apiClient
          .get(
            "/api/user/exists/?email=" +
              this.chosen.email +
              "&bt=" +
              getParameterByName("bt"),
          )
          .then(function (response) {
            // TODO: this is (at least one place) where we should handle the user already existing, at least for messaging about "User already exists"
            // okay, so if the user exists but has a valid bt, carry on as if there's no issue
            // if the user exists and has an invitation but no valid bt, show a special message

            if (response.data.status === false) {
              that.spinStop(spinId);
              that.completeAccount();
            } else if (response.data.status == 99) {
              that.spinStop(spinId);
              that.saExistsMessage = that.showMessage(
                "This email address was previously used to record a Selfie Assessment. Please check your email to set your password and then come back to this page to log in and complete the booking process. If you have any questions, email us at contact@initialview.com!",
                "alert-warning",
              );
            } else {
              that.showMessage(
                "A user with this email address already exists - please log in or use a different email.",
                "alert-warning",
                that.uiMessageWaitLong,
              );
              that.spinStop(spinId);
            }
          })
          .catch(function () {
            that.showMessage(
              "Problem contacting server, please retry.",
              "alert-danger",
              that.uiMessageWaitShort,
            );
            that.spinStop(spinId);
          });
      } else {
        that.showMessage(
          "Passwords do not match",
          "alert-warning",
          that.uiMessageWaitLong,
        );
      }
    },

    user_login_check_token: function () {
      this.hideMessage(this.saExistsMessage);
      this.loginAttempt = true;
      this.user_login();
    },

    // move this to user-account-mixin when we have a second use case for creating users
    user_signup: function () {
      var that = this;
      var spinId = this.spinStart();

      var bt = getParameterByName("bt");

      apiClient
        .post("/api/user/sign_up/", {
          email: that.chosen.email,
          password: that.password,
          first_name: that.chosen.firstName,
          last_name: that.chosen.lastName,
          birthday:
            that.chosen.birthyear +
            "-" +
            that.chosen.birthmonth +
            "-" +
            that.chosen.birthdate,
          cell: that.chosen.cell,
          bt: bt,
        })
        .then(function () {
          that.spinStop(spinId);
          that.loginemail = that.chosen.email;
          that.loginpassword = that.password;
          that.user_login();
          if (!that.couponIsPsp) {
            that.goNext("policy");
          }
        })
        .catch(function (error) {
          that.spinStop(spinId);
          console.log(error);
          var backendMessage =
            error.response &&
            error.response.data &&
            error.response.data.message;
          that.showMessage(
            backendMessage ||
              "Oops! Looks like you missed something? If you need help, please email: contact@initialview.com.",
            "alert-warning",
            that.uiMessageWaitLong,
          );
        });
    },

    fetchCalendarEvents: function () {
      var that = this;
      ////dev data
      // var list = [{
      //     date: '2016-05-30',
      //     time: '1:00PM',
      //     count: 988
      // }, {
      //     date: '2016-05-11',
      //     time: '12:00AM (midnight)',
      //     count: 2
      // }, {
      //     date: '2016-05-10',
      //     time: '12:00PM (noon)',
      //     count: 5
      // }, {
      //     date: '2016-05-17',
      //     time: '4:00PM',
      //     count: 5
      // }]
      var spinId = this.spinStart();

      var list = [];
      //////get list with location based API call and update.
      apiClient
        .get("/api/interview/timeslot/", {
          params: {
            groupby: "hour",
            location: that.chosen.locCity,
            start_date: moment.utc().format(),
            end_date: moment.utc().add(12, "months").format(),
            iv_type: that.chosen.iv_type,
            coupon: that.chosen.coupon,
            time_slot_tag: that.chosen.timeSlotTag,
            only_tagged: that.chosen.onlyTagged,
          },
        })
        .then(
          function (request) {
            //console.log(request);
            var k,
              t,
              tf,
              c,
              e = "";
            for (k in request.data) {
              //console.log(k);
              t = moment(k).tz(that.chosen.locTz);
              //console.log(t);
              c = request.data[k];
              tf = t.format("h:mm A");
              if (t.hour() == 0) {
                tf = tf + " (Midnight)";
              }
              if (t.hour() == 12) {
                tf = tf + " (Noon)";
              }
              e = {
                date: t.format("MMMM D, YYYY"),
                time: tf,
                count: c,
                utc: k,
              };
              list.push(e);
            }

            Vue.set(that, "timeList", list);
            bookingClndr.setEvents(that.timeList);
            Vue.set(that, "clndrDay", "Pick a day.");
            that.spinStop(spinId);

            Vue.set(that, "clndrMonth", bookingClndr.month.format("MMMM YYYY"));
            window.clearTimeout(that.currentTimeoutId);
            var timeoutId = window.setTimeout(function () {
              Vue.set(that, "currentTimeoutId", null);
              if (that.isEmptyMonth(bookingClndr.month)) {
                that.showEmptyMonthModal();
              }
            }, 1000);
            Vue.set(that, "currentTimeoutId", timeoutId);
            console.log("current timeout id: " + timeoutId);
          },
          function () {
            that.spinStop(spinId);
            that.showMessage(
              "Sorry, no times found",
              "alert-warning",
              this.uiMessageWaitLong,
            );
            that.showEmptyMonthModal();
          },
        );
    },

    classBynslotsPerDay: function (day) {
      var that = this;
      var nslots = -1;
      if (day.events.length) {
        // nslots = 0;
        // day.events.forEach(function(e) {
        //  nslots += e.count;
        // });
        nslots = day.events.length;
      }

      if (that.chosen.locCity == "Webcam") {
        if (nslots > 3) {
          return "plenty-slots";
        } else if (nslots > 0) {
          return "few-slots";
        } else if (nslots == 0) {
          return "no-slots";
        }
      } else {
        if (nslots > 3) {
          return "plenty-slots";
        } else if (nslots > 0) {
          return "few-slots";
        } else if (nslots == 0) {
          return "no-slots";
        }
      }
      // return nslots;
      // :class="{'plenty-slots': nslotsForDay(day) > 3, 'few-slots': nslotsForDay(day) > 0 && nslotsForDay(day) < 3, 'no-slots': nslotsForDay(day) == 0}"
    },

    //email validation
    isEmail: function (email) {
      var regex =
        /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      return regex.test(email);
    },

    isAlpha: function (cell) {
      var regex = /^[a-zA-Z\s-]+$/;
      return regex.test(cell);
    },

    pickDay: function (date) {
      var nd = date.format("MMMM D, YYYY");
      Vue.set(this, "clndrDay", nd);
      //jump to available times
      $("html, body").animate({
        scrollTop: $(".availableTimesBox").offset().top,
      });
    },

    scrollToTop: function () {
      setTimeout(function () {
        $("html, body").animate({
          scrollTop: $("body").offset().top,
        });
      }, this.uiFadeTime / 2);
    },

    switchChosenType: function () {
      var that = this;
      Vue.set(that, "modalHiddenEventEnabled", false);
      var baseUrl = window.location.href.split("#")[0];
      window.location.replace(baseUrl + "#time");
      if (this.chosen.type.v == 2) {
        location.hash = "locationTz";
      } else {
        location.hash = "locationCity";
      }
    },

    changeLocations: function () {
      var that = this;
      Vue.set(that, "modalHiddenEventEnabled", false);
      var baseUrl = window.location.href.split("#")[0];
      window.location.replace(baseUrl + "#time");
      if (this.chosen.type.v == 2) {
        location.hash = "locationCity";
      } else {
        location.hash = "locationTz";
      }
    },

    checkCoupon: function () {
      var that = this;
      var spinId = this.spinStart();
      // var messageId = this.showMessage("checking coupon...", "alert-warning", this.uiMessageWaitLong);
      var code = this.chosen.coupon;
      var iv_type = this.chosen.iv_type;
      if (code != null) {
        apiClient
          .get("/api/interview/coupon/", {
            params: {
              c: code,
              iv_type: iv_type,
              timeslot: this.chosen.utc,
            },
          })
          .then(
            function (request) {
              // that.hideMessage(messageId);
              if (request.data.value === false) {
                Vue.set(that.chosen, "couponValid", false);
                that.spinStop(spinId);
                that.showMessage(
                  request.data.message || "Coupon not valid",
                  "alert-danger",
                  that.uiMessageWaitLong,
                );
              } else {
                Vue.set(that.chosen, "coupon", code);
                Vue.set(that, "couponMultiplyer", request.data.value);
                Vue.set(
                  that,
                  "couponIsPsp",
                  request.data.processing ? true : false,
                );
                Vue.set(that, "rush_only", request.data.rush_only);
                if (request.data.processing) {
                  that.chosen.rushID = request.data.processing.id;
                  that.chosen.rushProcessingDays =
                    request.data.processing.processingDays;
                  that.chosen.rushPriceRMB =
                    request.data.processing.rushPriceRMB;
                  that.chosen.rushPriceUSD =
                    request.data.processing.rushPriceUSD;
                }
                Vue.set(that.chosen, "couponValid", true);
                $("#couponInput").prop("disabled", true);
                that.spinStop(spinId);
                if (request.data.rush_only) {
                  that.showMessage(
                    request.data.processing.priceLanguage,
                    "alert-success",
                    that.uiMessageWaitLong,
                  );
                }
                //  else {
                // that.showMessage("Great! Coupon is valid for a " + that.computePercent + "% discount.", "alert-success", that.uiMessageWaitLong);
                // }
              }
            },
            function () {
              Vue.set(that.chosen, "couponValid", false);
              that.spinStop(spinId);
              that.showMessage(
                "Please wait a few moments and then refresh the page to try again - if the problem persists, contact us at contact@initialview.com!",
                "alert-danger",
                this.uiMessageWaitLong,
              );
            },
          );
      }
    },

    applyTag: function () {
      var that = this;

      that.chosen.type = {
        v: 1,
        textValue: "Global (Webcam)",
      };
      that.chosen.applyingFor = "Job";
      that.chosen.iv_type = "job";

      that.completeLocationTz({
        subtitle: "GMT -04:00 hours",
        timezone: "America/New_York",
        title: "New York",
      });
    },

    callBookingApi: function () {
      var that = this;
      var spinId = this.spinStart();

      if (this.context == "booking") {
        var bookrequest = {
          location: this.chosen.locCity,
          iv_type: this.chosen.iv_type,
          time: this.chosen.utc,
          coupon: this.chosen.couponValid ? this.chosen.coupon : null,
          rush: this.chosen.rushID,
          invite: this.chosen.invite,
          tz_city: this.chosen.locTzName,
        };

        //do some final re-validation here??? (future)
        apiClient.post("/api/interview/booking/", bookrequest).then(
          function (request) {
            if (request.data.status != 200) {
              console.log("request.data.status != 200");
              that.showMessage(
                "Booking Unsuccessful: " + request.data.message,
                "alert-danger",
                that.uiMessageWaitLong,
              );
              //look over your data and the rules
              that.goNext("bookfail");
              that.spinStop(spinId);
              return false;
            } else {
              // apiClient.post('/api/mulgrave/registration/', that.reg).then(function (request) {
              that.showMessage(
                "Email Sent",
                "alert-success",
                that.uiMessageWaitLong,
              );
              that.goNext("email");
              that.spinStop(spinId);
              // });

              return true;
            }
          },
          function (request) {
            if (request.data) {
              that.showMessage(
                request.data.message,
                "alert-danger",
                that.uiMessageWaitLong,
              );
              console.log("request.data");
              that.goNext("bookfail");
            } else {
              that.showMessage(
                "Please wait a few moments and then refresh the page to try again - if the problem persists, contact us at contact@initialview.com!",
                "alert-danger",
                that.uiMessageWaitLong,
              );
            }
            that.spinStop(spinId);
            return false;
          },
        );
      }

      if (that.context == "reschedule") {
        var reschedule = {
          booking_id: that.booking_id,
          location: that.chosen.locCity,
          time: that.chosen.utc,
          rush: that.chosen.rushID,
          tz_city: that.chosen.locTzName,
        };

        apiClient
          .post("/api/interview/reschedule/", reschedule)
          .then(function (response) {
            if (response.data.status != 200) {
              that.showMessage(
                "Booking Unsuccessful: " + response.data.message,
                "alert-danger",
                that.uiMessageWaitLong,
              );
              //look over your data and the rules
              that.goNext("bookfail");
              that.spinStop(spinId);
              return;
            } else {
              that.payment_url = response.data.payment_url;
              that.goNext("payment");
              that.spinStop(spinId);
              return;
            }
          })
          .catch(function () {
            that.spinStop(spinId);
          });
      }

      if (that.context == "rushprocessing") {
        var rushprocessing = {
          booking_id: that.booking_id,
          rush: that.chosen.rushID,
        };

        apiClient
          .post("/api/interview/rush/", rushprocessing)
          .then(function (response) {
            if (response.data.status != 200) {
              that.showMessage(
                "Booking Unsuccessful: " + response.data.message,
                "alert-danger",
                that.uiMessageWaitLong,
              );
              //look over your data and the rules
              that.goNext("bookfail");
              that.spinStop(spinId);
              return;
            } else {
              that.payment_url = response.data.payment_url;
              that.goNext("payment");
              that.spinStop(spinId);
              return;
            }
          })
          .catch(function () {
            that.spinStop(spinId);
          });
      }
    },

    goBackToStart: function () {
      location.hash = "splash";
    },

    goBackToLocationCity: function () {
      location.hash = "locationCity";
    },

    goBackToInfo: function () {
      if (this.context == "booking") {
        location.hash = "info";
      } else {
        location.hash = "rush";
      }
    },

    goToHash: function (destination, returnTo) {
      Vue.set(this, "uiReturn", returnTo);
      location.hash = destination;
    },

    //this function is called when a screen is completed.
    //it handles any "uiReturn" jumps requested
    goNext: function (next) {
      var goHere = "";
      if (this.uiReturn === null) {
        goHere = next;
      } else {
        goHere = this.uiReturn;
        Vue.set(this, "uiReturn", null);
        //reset uiReturn.
      }
      setTimeout(function () {
        $("html, body").animate({
          scrollTop: $("body").offset().top,
        });
        location.hash = goHere;
      }, 100);
    },

    ////

    completePreSplash: function (i) {
      // console.log(i);
      this.goNext("splash");
    },

    completeSplash: function (i) {
      // console.log(i);
      var newType = {
        v: i.v,
        textValue: i.textValue,
      };
      Vue.set(this.chosen, "type", newType);
      this.goNext("type");
    },

    completeType: function (i) {
      Vue.set(this.chosen, "applyingFor", i.title);
      this.asessement_type = i.subtitle;
      this.reg.grade = i.title;
      Vue.set(this.chosen, "iv_type", i.v);
      Vue.set(this.chosen, "priceRMB", i.priceRMB);
      Vue.set(this.chosen, "priceUSD", i.priceUSD);
      if (this.chosen.type.v == 1) {
        this.goNext("locationTz");
      } else {
        this.goNext("locationCity");
      }
    },

    completeLocationCity: function (i) {
      // console.log(i);
      var c = this.chosen;
      c.locTzName = "n/a";
      c.locTz = i.timezone;
      c.locCity = i.title;
      this.reg.timezone = i.timezone;
      c.type = {
        v: 2,
        textValue: "In-Studio",
      };
      Vue.set(this, "chosen", c);
      this.fetchCalendarEvents();
      this.goNext("time");
    },

    completeLocationTz: function (i) {
      // console.log(i);
      var c = this.chosen;
      c.locTzName = i.title;
      c.locTz = i.timezone;
      this.reg.timezone = i.timezone;
      c.locCity = "Webcam";
      c.type = {
        v: 1,
        textValue: "Global (Webcam)",
      };
      Vue.set(this, "chosen", c);
      this.fetchCalendarEvents();
      this.goNext("time");
    },

    completeTime: function (i) {
      var that = this;
      Vue.set(that, "modalHiddenEventEnabled", false);
      var baseUrl = window.location.href.split("#")[0];
      window.location.replace(baseUrl + "#time");
      console.log(i);
      Vue.set(this.chosen, "utc", i.utc);
      if (this.chosen.coupon) {
        that.checkCoupon();
      }
      this.goNext("details");
    },

    completeDetails: function (i) {
      this.goNext("account");
      // if (this.couponIsPsp) {
      //     this.goNext("account");
      // } else {
      //     if (this.rushability !== null) {
      //         this.goNext("rush");
      //     } else {
      //         this.completeRush()
      //     }
      // }
    },

    selectRush: function (i) {
      var c = this.chosen;
      c.rushID = i.id;
      c.rushProcessingDays = i.processingDays;
      c.rushPriceRMB = i.rushPriceRMB;
      c.rushPriceUSD = i.rushPriceUSD;
      Vue.set(this, "chosen", c);
    },

    completeRush: function (i) {
      if (this.context == "booking") {
        location.hash = "account";
        // this.goNext("account");
      } else {
        location.hash = "terms";
        // this.goNext("terms");
      }
    },

    completeAccount: function () {
      //make sure user is logged in OR passwords match and user does not exist
      // see: user_login or new_account_form depending on button clicked.
      if (this.user) {
        this.goNext("terms");
      } else if (this.isEmail(this.chosen.email)) {
        this.goNext("info");
      } else {
        this.showMessage(
          "Invalid email",
          "alert-warning",
          this.uiMessageWaitLong,
        );
      }
    },

    completeInfo: function () {
      //validate personal info
      if (
        this.chosen.lastName == "" ||
        this.isAlpha(this.chosen.lastName) == false
      ) {
        this.showMessage(
          "Last name: Please use English alphabet",
          "alert-warning",
          this.uiMessageWaitLong,
        );
      } else if (
        this.chosen.firstName == "" ||
        this.isAlpha(this.chosen.firstName) == false
      ) {
        this.showMessage(
          "First name: Please use English alphabet",
          "alert-warning",
          this.uiMessageWaitLong,
        );
      } else if (
        this.chosen.birthyear == "" ||
        this.chosen.birthmonth == "" ||
        this.chosen.birthdate == ""
      ) {
        this.showMessage(
          "Check birthdate input",
          "alert-warning",
          this.uiMessageWaitLong,
        );
      } else if (this.chosenValid == false) {
        this.showMessage(
          "Check mobile number",
          "alert-warning",
          this.uiMessageWaitLong,
        );
      } else if (this.isEmail(this.chosen.email) == false) {
        this.showMessage(
          "Check email input",
          "alert-warning",
          this.uiMessageWaitLong,
        );
      } else {
        this.reg.lastname = this.chosen.lastName;
        this.reg.firstname = this.chosen.firstName;
        this.reg.birthday =
          this.chosen.birthyear +
          "-" +
          this.chosen.birthmonth +
          "-" +
          this.chosen.birthdate;
        this.reg.mobile = this.chosen.cell;
        this.reg.email = this.chosen.email;
        this.goNext("terms");
      }
    },

    completeTerms: function (i) {
      // console.log(i);
      if (this.sayYesToAgree.toUpperCase() === "YES") {
        this.goNext("summary");
      } else {
        this.showMessage(
          'Type "yes" if you agree. ',
          "alert-warning",
          this.uiMessageWaitLong,
        );
      }
    },

    completeSummary: function () {
      // see: completeAccount
      // if user is logged in there, this will just let them contiue
      // if not logged in this stage is where the user gets created.
      if (this.context != "booking") {
        this.goNext("policy");
        return;
      }

      if (this.user) {
        if (this.couponIsPsp) {
          this.callBookingApi();
        } else {
          this.goNext("policy");
        }
      } else {
        this.user_signup();
      }
    },

    completePolicy: function () {
      // console.log(i);
      // send "book interview" api call.
      if (this.sayYesToAgreePolicy.toUpperCase() === "YES") {
        this.callBookingApi();
      } else {
        this.showMessage(
          'Type "yes" if you agree. ',
          "alert-warning",
          this.uiMessageWaitLong,
        );
      }
    },

    completeEmail: function (i) {
      // console.log(i);
      //send link to email.
      //location.hash = "pay";
    },

    isEmptyMonth: function (month) {
      var monthString = month.format("MMMM");
      var yearString = month.format("YYYY");
      var filtered = this.timeList.filter(function (t) {
        return (
          t.date.indexOf(monthString) > -1 && t.date.indexOf(yearString) > -1
        );
      });
      console.log(JSON.stringify(this.timeList));
      console.log(JSON.stringify(filtered));
      console.log(filtered.length);
      return filtered.length == 0;
    },

    showDayModal: function () {
      this.openModal("myModal");
    },

    showEmptyMonthModal: function () {
      this.openModal("emptyMonthModal");
    },

    showRequestTimeModal: function () {
      this.openModal("requestTimeModal");
    },

    showAfterTimeRequestModal: function () {
      this.openModal("afterTimeRequestModal");
    },

    goToNextMonth: function () {
      var that = this;
      this.closeModal("emptyMonthModal");
      window.setTimeout(function () {
        bookingClndr.month = bookingClndr.next().month;
        Vue.set(that, "clndrMonth", bookingClndr.month.format("MMMM YYYY"));
        window.clearTimeout(that.currentTimeoutId);
        var timeoutId = window.setTimeout(function () {
          Vue.set(that, "currentTimeoutId", null);
          console.log(bookingClndr.month.format("MMMM YYYY"));
          if (that.isEmptyMonth(bookingClndr.month)) {
            that.showEmptyMonthModal();
          }
        }, 1000);
        Vue.set(that, "currentTimeoutId", timeoutId);
        console.log("current timeout id: " + timeoutId);
      }, 500);
    },

    goToPreviousMonth: function () {
      var that = this;
      this.closeModal("emptyMonthModal");
      window.setTimeout(function () {
        bookingClndr.month = bookingClndr.previous().month;
        Vue.set(that, "clndrMonth", bookingClndr.month.format("MMMM YYYY"));
        window.clearTimeout(that.currentTimeoutId);
        var timeoutId = window.setTimeout(function () {
          Vue.set(that, "currentTimeoutId", null);
          console.log(bookingClndr.month.format("MMMM YYYY"));
          if (that.isEmptyMonth(bookingClndr.month)) {
            that.showEmptyMonthModal();
          }
        }, 1000);
        Vue.set(that, "currentTimeoutId", timeoutId);
        console.log("current timeout id: " + timeoutId);
      }, 500);
    },

    requestTime: function (type) {
      var that = this;
      if (type == 1) {
        this.closeModal("myModal");
      } else {
        this.closeModal("emptyMonthModal");
      }
      var getDefaultDate = function () {
        if (type == 1) {
          return that.clndrDay;
        } else {
          return moment(that.clndrMonth, "MMMM YYYY").format("MMMM D, YYYY");
        }
      };
      window.setTimeout(function () {
        Vue.set(that.request, "date", getDefaultDate());
        that.showRequestTimeModal();
      }, 500);
    },

    sendRequest: function () {
      var that = this;
      console.log(this.request);
      if (this.request.name == "") {
        this.showMessage(
          "Please enter your name",
          "alert-warning",
          this.uiMessageWaitLong,
        );
        return;
      }
      if (!this.isEmail(this.request.email)) {
        this.showMessage(
          "Invalid email",
          "alert-warning",
          this.uiMessageWaitLong,
        );
        return;
      }
      if (!this.requestValid) {
        this.showMessage(
          "Invalid mobile number",
          "alert-warning",
          this.uiMessageWaitLong,
        );
        return;
      }
      var body = {
        date: this.request.date,
        name: this.request.name,
        email: this.request.email,
        phone: this.request.phone,
        reason: this.request.reason,
        location: "",
      };
      if (this.chosen.type.v == 1) {
        body.location = "Webcam";
      } else {
        body.location = this.chosen.locCity;
      }
      Vue.set(this, "request", {
        date: "",
        name: "",
        email: "",
        phone: "",
        reason: "",
      });
      $("#requestForm")[0].reset();
      this.closeModal("requestTimeModal");
      window.setTimeout(function () {
        Vue.set(that, "requestFailed", false);
        Vue.set(that, "requestLoading", true);
        that.showAfterTimeRequestModal();
        apiClient
          .post("/api/interview/request/", body)
          .then(function (response) {
            if (response.data.status == 200) {
              Vue.set(that, "requestLoading", false);
            } else {
              Vue.set(that, "requestFailed", true);
              Vue.set(that, "requestLoading", false);
            }
          })
          .catch(function () {
            that.spinStop(spinId);
          });
      }, 500);
    },

    paymentFinished: function () {
      ivbus.$emit("orderComplete", {
        context: this.context,
        booking_id: this.booking_id,
        chosen: this.chosen,
      });
    },
  },

  filters: {
    upper: function (value) {
      if (!value) {
        return "";
      }
      value = value.toString();
      var result = "";
      for (var i = 0; i < value.length; i++) {
        result += value.charAt(i).toUpperCase();
      }
      return result;
    },
  },
};
</script>

<style scoped>
body {
  background-color: #e9ecef;
}
.navbar-brand {
  padding: 0 0 0 10px !important;
  height: 69px !important;
}
.vue-tel-input.has-error {
  border-color: #a94442;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}
.vue-tel-input .vti__selection {
  white-space: nowrap;
}
.container-block {
  width: 400px;
  margin-top: 15px;
}
@media (max-width: 399px) {
  .container-block {
    width: 100%;
    margin-top: 15px;
  }
}
/* style for calendar */

.clndr-grid {
  padding-top: 10px;
}
.days {
  padding-top: 7px;
}

.day-selected {
  background: #4f7aba;
}

.day-number {
  position-top: 0px;
  line-height: 37px;
}

#booking-clndr .clndr-grid .days .day > div {
  width: calc(100% + 20px) !important;
  height: calc(100% + 20px);
  position: relative;
  left: -10px;
  top: -10px;
}
#booking-clndr .clndr-grid .days .day:hover > div {
  box-shadow: 0px 0px 3px 1px rgba(0, 0, 0, 0.4);
}
#booking-clndr
  > div
  > div.clndr-left
  > div.clndr-grid
  > div.days
  > div
  > div
  > span {
  left: 14px;
  top: 0px;
  font-size: 10pt;
  color: #9b9b9a;
  z-index: 1;
  position: absolute;
  cursor: default !important;
}
#booking-clndr .clndr-grid .days .day:after {
  content: "";
  display: block;
  width: 35px !important;
  height: 35px;
  position: absolute;
  right: 0px;
  bottom: 0px;
  box-sizing: border-box;

  background-image: url("../../../components/img/booking/gray-trig.png");
}

#booking-clndr .clndr-grid .days .day.sunday:after,
.adjacent-month:after {
  background-image: none !important;
}
#booking-clndr .clndr-grid .days .day.plenty-slots:after {
  background-image: url("../../../components/img/booking/plenty.png");
}
#booking-clndr .clndr-grid .days .day.few-slots:after {
  background-image: url("../../../components/img/booking/few.png");
}

a .edit-button {
  color: #e96724;
}

.control-label {
  font-weight: normal;
}

.fieldTitle {
  color: #e96724;
  padding-bottom: 20px;
  font-size: 12pt;
}

.fieldValue {
  font-size: 12pt;
}

.btn-orange {
  background-color: #e96724 !important;
  color: white;
  text-shadow: none;
  border: 1px solid darkgray;
}
.btn-orange:hover {
  background-color: #de5800 !important;
  color: white;
  text-shadow: none;
}

.btn-danger {
  background-color: #d9534f !important;
  color: white;
  text-shadow: none;
  border: 1px solid darkgray;
}
.btn-danger:hover {
  background-color: #d9534f !important;
  color: white;
  text-shadow: none;
}

.btn-warning {
  background-color: #f0ad4e !important;
  color: white;
  text-shadow: none;
  border: 1px solid darkgray;
}
.btn-warning:hover {
  background-color: #f0ad4e !important;
  color: white;
  text-shadow: none;
}

.btn-default {
  background-color: #fff !important;
  color: #333;
  text-shadow: none;
  border: 1px solid darkgray;
}
.btn-default:hover {
  background-color: #eee !important;
  color: #222;
  text-shadow: none;
}

.checkbox-inline {
  color: #5d7294;
}

.time-view-note {
  font:
    italic 15px "Lato",
    sans-serif;
  margin: 0px 40px 20px !important;
  text-align: center;
}

.availableTimesBox {
  /* border: 3px solid #79a9ad; */
}

.availableTimesTitle {
  font-size: 18pt;
  color: #2a606e;
  /* background-color:white; */
  background-image: none;
}

.timeZoneTitle {
  color: #2a606e;
  /* color: white; */
  /* background-color: #79a9ad; */
  background-image: none;
}

div#accordion.timezone .panel-title {
  line-height: 1.5;
}

div#accordion.timezone .panel {
  border: 0;
}

.timezone-heading {
  border-style: solid;
  border-top-width: 5px;
  border-top-color: #e96724;
  border-radius: 0px;
  color: #ffffff;
  background-color: #e96724;
  border-left: 0px;
  border-right: 0px;
  width: 100%;
  text-align: left;
}

.timezone-heading.collapsed {
  background-color: #ffffff;
  color: #686868;
}

/***********  CSS shapes  ***********/

.timezone-heading.collapsed .arrow {
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;

  border-top: 13px solid #e96724;
  padding-top: 1px;
  margin-top: 5px;
}

.timezone-heading .arrow {
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;

  border-bottom: 13px solid #ffffff;
  padding-top: 1px;
  margin-top: 5px;
}

.arrow-down {
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;

  border-top: 13px solid #e96724;
  padding-top: 1px;
  margin-top: 5px;
}

.arrow-up {
  width: 0;
  height: 0;
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;

  border-bottom: 13px solid #ffffff;
  padding-top: 1px;
}

.circle {
  border-radius: 50%;
  width: 22px;
  height: 22px;
  border: 2px solid #686868;
  color: #e96724;
}

.wrapper {
  position: relative;
}

.wrapper .glyphicon {
  position: absolute;
  top: 4px;
  left: 4px;
  color: #e96724;
}

.clndr-grid {
  width: 100%;
  background-color: white;
  font-weight: 700;
  -moz-box-shadow: 0px 4px 0 #343434;
  /* -webkit-box-shadow: 0px 4px 0 #343434; */
  /* box-shadow: 0px 4px 0 #343434; */
}
#booking-clndr .clndr-controls {
  /* padding: 14px; */
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 14px;
  padding-right: 14px;
  background-color: white !important;
  color: #e96724 !important;
  text-align: center;
  height: 40px !important;
  line-height: 30px;
  font-size: 20px;
}
#booking-clndr .clndr-controls .clndr-previous-button {
  float: left;
  text-align: left;
  background-image: url("/s/img/booking/arrow-left.png");
  background-repeat: no-repeat;
  background-position: center;
}
#booking-clndr .clndr-controls .clndr-next-button {
  float: right;
  text-align: right;
  background-image: url("/s/img/booking/arrow-right.png");
  background-repeat: no-repeat;
  background-position: center;
}
#booking-clndr .clndr-controls .clndr-previous-button,
#booking-clndr .clndr-controls .clndr-next-button {
  /* width: 30px; */
  color: transparent !important;
  width: 30px !important;
  height: 30px !important;
  line-height: 30px;
  text-align: center;
  font-size: 30px;
  border-radius: 50%;
  -webkit-user-select: none;
  /* Chrome/Safari */
  cursor: pointer;
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* IE10+ */
  background-color: #ebeff1;
}
#booking-clndr .clndr-controls .clndr-previous-button:hover,
#booking-clndr .clndr-controls .clndr-next-button:hover {
  /* opacity: 0.5; */
}
#booking-clndr .clndr-grid {
  float: left;
  /* width: 65%; */
  /* border-right: 2px solid white;*/
}
#booking-clndr .clndr-grid .days-of-the-week {
  width: 100% !important;
  height: 20px !important;
  background-color: #e96724 !important;
  line-height: 20px !important;
}
#booking-clndr .clndr-grid .days-of-the-week .header-day {
  float: left !important;
  width: 14.2857% !important;
  /* padding: 14px; */
  text-align: center !important;
  color: white !important;
}
#booking-clndr .clndr-grid .days {
  width: 100% !important;
  background-color: white;
}
#booking-clndr .clndr-grid .days .day,
#booking-clndr .clndr-grid .days .empty {
  position: relative;
  /* padding: 5px; */
  /* padding-left: 5px; */
  /* padding-right: 5px; */
  float: left;
  margin-left: 10px;
  width: calc(14.28571% - 20px) !important;
  height: 35px;
  margin-right: 10px;
  margin-left: 10px;
  margin-top: 5px;
  margin-bottom: 10px;
  line-height: 50px;
  /* height: 66px; */
  /* padding: 24px 0; */
  text-align: center;
  color: #4f4f4f;
  background-color: #ebeff1;
  /* border-bottom: 2px solid white; */
  /* background-size: cover; */
  /* background-position: center; */
  /* box-sizing: border-box; */
  box-sizing: border-box;
  border: 5px transparent;
}
#booking-clndr .clndr-grid .days .day.plenty-slots,
#booking-clndr .clndr-grid .days .empty.plenty-slots {
  /* background-color: #0BD318; */
  -webkit-transition: background-color 0.5s;
  -moz-transition: background-color 0.5s;
  -ms-transition: background-color 0.5s;
  -o-transition: background-color 0.5s;
  transition: background-color 0.5s;
  cursor: pointer;
}
#booking-clndr .clndr-grid .days .day.few-slots,
#booking-clndr .clndr-grid .days .empty.few-slots {
  /* background-color: #87FC70; */
  -webkit-transition: background-color 0.5s;
  -moz-transition: background-color 0.5s;
  -ms-transition: background-color 0.5s;
  -o-transition: background-color 0.5s;
  transition: background-color 0.5s;
  cursor: pointer;
}
#booking-clndr .clndr-grid .days .day.adjacent-month .day-number,
#booking-clndr .clndr-grid .days .empty.adjacent-month .day-number {
  opacity: 0;
}
#booking-clndr .clndr-grid .days .today {
  /* background-color: white; */
  /* background-image: none; */
}
#booking-clndr .event-listing {
  margin-left: 30px;
  box-sizing: border-box;
  float: left;
  width: 35%;
  height: 370px;
  border: 3px solid #e96724;
}
#booking-clndr .event-listing .event-listing-title {
  /* padding: 14px; */
  height: 57px;
  line-height: 57px;
  background-color: white;
  text-align: center;
  color: #e96724;
  font-size: 26px;
  letter-spacing: 1px;
}
#booking-clndr .event-listing .event-item {
  padding: 14px;
  color: #4f4f4f;
  cursor: pointer;
  margin: 10px 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  font-size: 20px;
  letter-spacing: 5px;
  color: #e96724;
  border: 4px solid #d1d4d4;
  -webkit-transition: all 0.2s linear 0s;
  -moz-transition: all 0.2s linear 0s;
  -ms-transition: all 0.2s linear 0s;
  -o-transition: all 0.2s linear 0s;
  transition: all 0.2s linear 0s;
}
#booking-clndr .event-listing .event-item:hover {
  border: 4px solid #e96724;
  color: white;
  background-color: #e96724;
}
#booking-clndr .event-listing .event-item-subtitle {
  font-weight: 400;
}
#booking-clndr .event-listing .event-item-time {
  display: none;
}
#booking-clndr .event-listing .selected {
  border: 4px solid #e96724;
  color: white;
  background-color: #e96724;
}
.noselect {
  -webkit-user-select: none;
  /* Chrome/Safari */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* IE10+ */
}
.days-of-the-week.clearfix {
  margin: 0;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
}
.block {
  padding: 80px 0;
  width: 100%;
}
.inner {
  max-width: 960px;
  padding: 0 20px;
  margin: 0 auto;
}
.clearfix:after {
  content: ".";
  display: block;
  clear: both;
  visibility: hidden;
  line-height: 0;
  height: 0;
}
.clearfix {
  display: inline-block;
}
html[xmlns] .clearfix {
  display: block;
}
* html .clearfix {
  height: 1%;
}
strong {
  font-weight: 700;
}
.bg-gray {
  background-color: #414141;
}
.bg-red {
  background-color: #ff5a45;
}
.bg-red a {
  color: #ff5a45;
}
.bg-red a:hover {
  background-color: #ffb4ab;
  color: #212121;
}
.bg-blue {
  background-color: #71bbd2;
}
.bg-green {
  background-color: #97ce7f;
}
.bg-yellow {
  background-color: #ddca9a;
}
.center {
  text-align: center;
}
.header {
  padding: 30px 0;
}
.banner-text {
  text-align: center;
  color: #f4f4f4;
  letter-spacing: 1px;
  font-weight: normal;
  text-shadow: 2px 2px 2px #212121;
}
.banner-text.below {
  margin-top: 30px;
}
.banner-text.below a {
  background-color: transparent;
  color: #97ce7f;
}
.banner-text.below a:hover {
  color: #d3eac9;
}
.more-space {
  margin-top: 3em;
}
@media all and (max-width: 768px) {
  #booking-clndr .clndr-grid {
    width: 100%;
    border: none;
  }
  #booking-clndr .event-listing {
    display: none;
  }
  h1.banner-text {
    font-size: 28px;
  }
  .banner-text.below {
    font-size: 16px;
    word-wrap: break-word;
  }
  code[class*="language-"],
  pre[class*="language-"] {
    font-size: 14px;
  }
}

.highlight {
  background-color: #e8f1fe;
}
</style>
